import type { LocaleResources } from '../types';

export const pl = {
  common: {
    matrixEditLabel: 'Zmień nazwę wyświetlaną',
    matrixRestoreLabel: 'Przywróć nazwę katalogową',
    matrixPersonalLabelHint:
      'Nazwa tylko dla Twojego konta, wspólna dla Sprzedaży i Wysyłek. Nie zmienia katalogu.',
    matrixLabelSaveFailed: 'Nie zapisano nazwy. Odśwież dane i spróbuj ponownie.',
    matrixDisplayLabel: 'Twoja nazwa produktu',
    matrixLabelLimit: 'Od 1 do 80 znaków, zwykły tekst.',
    matrixLabelPreview: 'Podgląd',
    appName: 'Operacje KJÖTKOMPANIÐ',
    loading: 'Ładowanie…',
    readFromImage: 'Odczytaj ze zdjęcia',
    importOrderFile: 'Importuj plik zamówienia',
    fileImportReview: 'Przegląd importu pliku',
    pdfTextUnavailable: 'Ten PDF nie zawiera tekstu do automatycznego odczytu.',
    storeMatches: 'SKLEP ZGODNY',
    possibleStoreMismatch: 'MOŻLIWA NIEZGODNOŚĆ SKLEPU: wykryto {{store}}.',
    selectedStore: 'Wybrany Sklep: {{store}}',
    imageReview: 'Przegląd odczytu zdjęcia',
    imageReadFailed: 'Nie udało się odczytać zdjęcia. Możesz wpisać zamówienie ręcznie.',
    fileImportFailed: 'Nie udało się odczytać pliku. Możesz wpisać zamówienie ręcznie.',
    reviewRequired: 'Wymaga weryfikacji',
    unit: 'Jednostka',
    addToDraft: 'Dodaj do draftu zamówienia',
    sources: 'Źródła',
    save: 'Zapisz',
    cancel: 'Anuluj',
    language: 'Język',
    appearance: 'Wygląd',
    appearanceLight: 'Jasny',
    appearanceDark: 'Ciemny',
    appearanceSystem: 'Systemowy',
    signedInAs: 'Zalogowano jako {{name}}',
    foundationReady: 'Fundament systemu jest gotowy',
    foundationDescription: 'Moduły operacyjne będą dostarczane w kolejnych zatwierdzonych etapach.',
    unavailable: 'Jeszcze niedostępne',
    quantityUnit: { PIECE: 'szt.', KG: 'kg' },
    errors: {
      MASTER_DATA_LOCK_TIMEOUT:
        'Inna operacja aktualizuje dane podstawowe. Odśwież dane i spróbuj ponownie.',
      technicalId: 'Identyfikator techniczny: {{id}}',
    },
    incompleteQuantity: 'Brakuje części dni raportowych; wartość obejmuje tylko dni potwierdzone.',
    fractionalPieceQuantity: 'Ułamkowa liczba sztuk wymaga weryfikacji.',
  },
  auth: {
    title: 'Bezpieczne logowanie',
    email: 'E-mail',
    code: 'Kod jednorazowy',
    requestCode: 'Wyślij kod',
    verifyCode: 'Zweryfikuj i zaloguj',
    signOut: 'Wyloguj',
    sent: 'Jeśli konto jest aktywne, kod jednorazowy został wysłany.',
    codeHint: 'Kod wygasa po około 10 minutach.',
    invalid: 'Nie udało się zweryfikować kodu.',
    sessionExpired: 'Sesja wygasła. Zaloguj się ponownie.',
  },
  navigation: {
    open: 'Otwórz nawigację',
    close: 'Zamknij nawigację',
    overview: 'Dane podstawowe',
    products: 'Produkty',
    abpCatalog: 'Katalog ABP',
    materials: 'Materiały i składniki',
    stores: 'Sklepy',
    networks: 'Sieci',
    users: 'Użytkownicy',
    settings: 'Ustawienia',
    stock: 'Stan zapasów',
    sales: 'Sprzedaż',
    shipments: 'Wysyłki',
    warehouse: 'Magazyn',
    production: 'Produkcja',
    forecast: 'Prognoza',
    costing: 'Kalkulator kosztów',
    productCostLibrary: 'Koszt produkcji produktów',
    costInputBase: 'Baza kosztów',
    profitability: 'Rentowność',
    orders: 'Zamówienia',
    analytics: 'Analityka',
    dashboard: 'Panel',
    operations: 'Operacje',
    importCenter: 'Centrum importu',
    overviewGroup: 'PRZEGLĄD',
    salesGroup: 'SPRZEDAŻ',
    operationsGroup: 'OPERACJE',
    economicsGroup: 'EKONOMIA',
    masterDataGroup: 'DANE PODSTAWOWE',
    collapseSidebar: 'Zwiń panel boczny',
    expandSidebar: 'Rozwiń panel boczny',
  },
  users: {
    title: 'Użytkownicy i dostęp',
    role: 'Rola',
    status: 'Status',
    active: 'Aktywny',
    deactivated: 'Dezaktywowany',
    managedByAdmin: 'Administracja użytkownikami jest chroniona uprawnieniami backendu.',
    createUser: 'Dodaj użytkownika',
    create: 'Utwórz użytkownika',
    cancel: 'Anuluj',
    close: 'Zamknij',
    email: 'E-mail',
    displayName: 'Nazwa wyświetlana',
    access: 'Nadpisania dostępu',
    actions: 'Akcje',
    manage: 'Zarządzaj',
    manageUser: 'Zarządzaj {{email}}',
    overrideCount_one: '{{count}} nadpisanie',
    overrideCount_other: '{{count}} nadpisania',
    actionFailed: 'Nie udało się zapisać zmiany dostępu. Spróbuj ponownie.',
    activate: 'Aktywuj',
    deactivate: 'Dezaktywuj',
    confirmActivate: 'Aktywować tego użytkownika?',
    confirmDeactivate: 'Dezaktywować użytkownika i unieważnić aktywne sesje?',
    revokeSessions: 'Unieważnij wszystkie sesje',
    effectiveAccess: 'Efektywny dostęp',
    effectiveAccessDescription: 'Domyślne uprawnienia roli i indywidualne nadpisania użytkownika.',
    permission: 'Uprawnienie',
    roleDefault: 'Domyślna rola',
    override: 'Nadpisanie',
    effective: 'Efektywne',
    inherit: 'Dziedzicz rolę',
    allow: 'Zezwól',
    deny: 'Odmów',
    roles: {
      ADMIN: 'Administrator',
      ELDHUS_MANAGER: 'Kierownik Eldhús',
      SALESMAN: 'Sprzedawca',
      VIEWER: 'Obserwator',
    },
    roleDescriptions: {
      ADMIN: 'Pełny dostęp operacyjny; rola i status są chronione.',
      ELDHUS_MANAGER: 'Kierownik operacyjny z dostępem do magazynu i danych podstawowych.',
      SALESMAN: 'Dostęp do sprzedaży i operacji handlowych.',
      VIEWER: 'Dostęp tylko do odczytu danych operacyjnych.',
    },
  },
  settings: {
    title: 'Ustawienia osobiste',
    languageTitle: 'Język interfejsu',
    languageDescription: 'Preferencja jest bezpiecznie zapisana na koncie użytkownika.',
    appearanceDescription: 'Wybierz jasny, ciemny lub zgodny z systemem wygląd aplikacji.',
    saved: 'Zapisano preferencję języka.',
  },
  validation: {
    required: 'To pole jest wymagane.',
    invalidEmail: 'Wpisz poprawny adres e-mail.',
    sixDigitCode: 'Wpisz sześciocyfrowy kod.',
    generic: 'Sprawdź wprowadzone wartości.',
  },
  master: {
    resultCount: 'Wyniki: {{count}}',
    previous: 'Poprzednia',
    next: 'Następna',
    viewSaved: 'Widok zapisany',
    saveView: 'Zapisz widok',
    search: 'Szukaj',
    status: 'Status',
    showAll: 'Pokaż wszystkie',
    sort: 'Sortowanie',
    updated: 'Zaktualizowano',
    notConfigured: 'Nie skonfigurowano',
    ready: 'Dane podstawowe są gotowe',
    readyDescription:
      'Zarządzaj kanoniczną konfiguracją produktów, sklepów i danych handlowych używaną w kolejnych etapach.',
    productsCard: 'Produkty',
    productsCardDescription: 'Katalog, jednostki, mapowania, dystrybucja i historia handlowa.',
    storesCard: 'Sklepy',
    storesCardDescription: 'Sieci, lokalizacje, kontakty, opinie, mapowania i aktywacja produktów.',
  },
  products: {
    title: 'Produkty',
    description: 'Kanoniczny katalog produktów i konfiguracja handlowa w czasie.',
    create: 'Utwórz produkt',
    sku: 'SKU',
    officialName: 'Nazwa oficjalna',
    displayAlias: 'Nazwa skrócona',
    category: 'Kategoria',
    salesUnit: 'Jednostka sprzedaży',
    financialUnit: 'Jednostka finansowa',
    operationalArea: 'Obszar operacyjny',
    netWeightKg: 'Masa netto (kg)',
    piecesPerTray: 'Sztuk na tacę',
    name: 'Nazwa',
    units: 'Jednostki',
    distribution: 'Dystrybucja w sieciach',
    salePriceNet: 'Cena sprzedaży NETTO',
    productionCostNet: 'Koszt produkcji NETTO',
    back: 'Wróć do produktów',
    general: 'Ogólne',
    unitsSummary: 'Sprzedaż: {{sales}} · Finanse: {{financial}} · Obszar: {{area}}',
    conversions: 'Przeliczniki jednostek produktu',
    fromUnit: 'Z jednostki',
    toUnit: 'Na jednostkę',
    factor: 'Przelicznik',
    effectiveFrom: 'Obowiązuje od',
    add: 'Dodaj',
    network: 'Sieć',
    mode: 'Tryb',
    directStore: 'Bezpośrednie uzupełnianie sklepów',
    centralSellThrough: 'Sprzedaż przez magazyn centralny',
    addVersion: 'Dodaj wersję',
    centralExplanation:
      'Tryb centralny nie oznacza zapasu sklepu, GOAL, punktu zamówienia ani alertów. Ustalenie bazowego stanu potoku należy do etapu zapasów.',
    storeActivation: 'Aktywacja w sklepach',
    store: 'Sklep',
    stores: 'Sklepy',
    salePriceHistory: 'Historia regularnych cen sprzedaży',
    netPrice: 'Cena jednostkowa netto ISK',
    costHistory: 'Historia kosztu produkcji',
    netCost: 'Koszt jednostkowy netto ISK',
    planningFoundation: 'Podstawa GOAL, zamówień i progów alertów',
    notCalculated:
      'Na tym etapie nie ma wartości obliczanych. Zapisywane są tylko jawne wersje ręczne dla dystrybucji bezpośredniej.',
    manualValue: 'Wartość ręczna',
    setGoal: 'Ustaw GOAL',
    setReorder: 'Ustaw ręczny punkt zamówienia',
    setThreshold: 'Ustaw ręczny próg',
    aliases: 'Aliasy źródłowe',
    source: 'Źródło',
    sourceSku: 'SKU źródłowe',
    sourceName: 'Nazwa źródłowa',
    provenance: 'Pochodzenie mapowania',
    audit: 'Historia audytu',
    categoryCode: 'Kod kategorii',
    categoryName: 'Nazwa kategorii',
    manageCategories: 'Zarządzaj kategoriami',
    createCategory: 'Utwórz kategorię',
    safetyBuffer: 'Bufor bezpieczeństwa',
    activate: 'Aktywuj',
    deactivate: 'Dezaktywuj',
    shipmentSourceRoute: 'Źródło wysyłki',
    noShipmentSourceRoute: 'Brak przypisania',
    routeReason: 'Powód zmiany trasy',
    saveShipmentSourceRoute: 'Zapisz trasę źródłową',
    shipmentSourceMatch: 'Dopasowanie SKU źródła Shipment',
    shipmentSourceMatchHelp:
      'Ręczne dopasowanie tworzy autorytatywny alias dla przyszłych importów Shipment.',
    matchShipmentSource: 'Dopasuj istniejący produkt',
    shipmentProductIntakeCount: 'Nowe SKU Shipment wymagające przeglądu: {{count}}',
    shipmentProductIntakeTitle: 'Przyjęcie nowych produktów Shipment',
    shipmentProductIntakeReview: 'Wymaga przeglądu',
    shipmentProductIntakeSku: 'SKU źródłowe',
    shipmentProductIntakeName: 'Produkt źródłowy',
    shipmentProductIntakeStatus: 'Status',
    shipmentProductIntakeSuggestion: 'Sugerowane dopasowanie / źródło',
    shipmentProductIntakeStatus_NEW: 'Nowy',
    shipmentProductIntakeStatus_MATCH_REVIEW_REQUIRED: 'Wymaga potwierdzenia dopasowania',
    shipmentProductIntakeStatus_UNASSIGNED: 'Wymaga decyzji o źródle',
    shipmentProductIntakeStatus_AUTO_CREATED: 'Utworzono automatycznie',
    shipmentProductIntakeStatus_RESOLVED: 'Rozwiązano',
  },
  stores: {
    title: 'Sklepy',
    description: 'Kanoniczne sklepy, kontakty, mapowania źródłowe i aktywacja produktów.',
    create: 'Utwórz sklep',
    network: 'Sieć',
    name: 'Nazwa sklepu',
    shortName: 'Nazwa skrócona',
    noPrimaryContact: 'Brak głównego kontaktu',
    activeProductsCount: 'Aktywne produkty: {{count}}',
    primaryContact: 'Główny kontakt',
    activeProducts: 'Aktywne produkty',
    aliases: 'Aliasy źródłowe',
    back: 'Wróć do sklepów',
    general: 'Ogólne',
    contacts: 'Kontakty',
    primary: 'Główny',
    deactivate: 'Dezaktywuj',
    activate: 'Aktywuj',
    contactName: 'Nazwa kontaktu',
    roleTitle: 'Rola / stanowisko',
    phone: 'Telefon',
    email: 'E-mail',
    setPrimary: 'Ustaw jako główny',
    addContact: 'Dodaj kontakt',
    feedback: 'Informacje operacyjne',
    feedbackText: 'Informacja',
    optionalProduct: 'Opcjonalny produkt',
    categoryTag: 'Kategoria / znacznik',
    addFeedback: 'Dodaj informację',
    product: 'Produkt',
    source: 'Źródło',
    rawAlias: 'Surowy alias / kod',
    provenance: 'Pochodzenie mapowania',
    addAlias: 'Dodaj alias',
    extendHistory: 'Rozszerz historię',
    audit: 'Historia audytu',
    editContact: 'Edytuj',
    updateContact: 'Zaktualizuj kontakt',
  },
  networks: {
    title: 'Sieci',
    description: 'Kanoniczne sieci handlowe współdzielone przez użytkowników.',
    create: 'Utwórz sieć',
    code: 'Kod',
    name: 'Nazwa kanoniczna',
    shortName: 'Nazwa skrócona',
    edit: 'Edytuj sieć',
  },
  inventory: {
    title: 'Zapasy',
    warehouseTitle: 'Zapasy magazynowe',
    description: 'Audytowany stan fizyczny z jawnym stanem nieznanym i odtwarzalną historią.',
    positions: 'Pozycje zapasu',
    openingStock: 'Stan otwarcia',
    physicalCount: 'Liczenie fizyczne',
    physicalCountHelp:
      'Zapisuje niezmienny stan z liczenia i jego różnicę względem obserwowanej ilości z ledgeru.',
    warehouseCorrection: 'Kontrolowana korekta',
    warehouseCorrectionHelp:
      'Zapisuje osobno audytowaną korektę magazynową; nigdy nie edytuje salda bezpośrednio.',
    countHistory: 'Historia liczeń i różnic',
    warehouseTransfer: 'Transfer magazynowy',
    warehouseTransferHelp:
      'Transfer jest niezmiennym ruchem między dwoma wcześniej zainicjowanymi pozycjami magazynowymi.',
    transferDestination: 'Magazyn docelowy',
    transferQuantity: 'Ilość do przeniesienia',
    submitTransfer: 'Zaksięguj transfer',
    transferPosted: 'Transfer zapisany. Źródło: {{from}}, cel: {{to}}.',
    history: 'Historia zapasu',
    pipeline: 'Pipeline sieci',
    locationKind: 'Typ lokalizacji',
    store: 'Sklep',
    warehouse: 'Magazyn',
    location: 'Lokalizacja',
    allLocations: 'Wszystkie lokalizacje',
    product: 'Produkt',
    unitFilter: 'Jednostka',
    allUnits: 'Wszystkie jednostki',
    current: 'Bieżąca ilość',
    actual: 'Fizycznie policzona ilość',
    quality: 'Jakość danych',
    stockStateLabel: 'Stan zapasu',
    revision: 'Rewizja',
    unknown: 'NIEZNANY',
    enterActual: 'Wprowadź stan fizyczny',
    physicalEntry: 'Inwentaryzacja i stan otwarcia',
    businessDate: 'Data operacyjna',
    reason: 'Powód',
    addOpeningLine: 'Dodaj do szkicu otwarcia',
    confirmOpening: 'Potwierdź stan otwarcia',
    submitCorrection: 'Zapisz korektę',
    submitPhysicalCount: 'Potwierdź liczenie fizyczne',
    warehouseCountPosted: 'Zapisano {{count}} pozycji liczenia fizycznego.',
    openingDraft: 'Szkic stanu otwarcia',
    date: 'Data',
    movement: 'Ruch',
    result: 'Wynik',
    variance: 'Różnica',
    varianceHelp: 'Fizycznie policzona ilość minus obserwowana ilość z ledgeru.',
    calculated: 'Ilość wyliczona',
    lastMovement: 'Ostatni ruch',
    lastPhysicalCount: 'Ostatnie liczenie',
    actions: 'Działania',
    countAction: 'Policz',
    correctAction: 'Koryguj',
    viewMovements: 'Ruchy',
    evidence: 'Dowód',
    pieceUnit: 'szt.',
    kilogramUnit: 'kg',
    estimatedPipeline: 'SZACOWANY PIPELINE SIECI',
    pipelineExplanation: 'To zweryfikowany baseline, a nie bieżące wyliczenie stanu sklepów.',
    pipelineRows: '{{count}} baseline pipeline',
    correctionPosted: 'Korekta zapisana. Delta rejestru: {{delta}}.',
    openingConfirmed: 'Potwierdzono {{count}} ruchów stanu otwarcia.',
    stockChanged: 'Stan zmienił się podczas edycji. Sprawdź odświeżoną ilość i wyślij ponownie.',
    operationFailed: 'Nie udało się wykonać operacji magazynowej.',
    stockWorkspaceTitle: 'Stan zapasów',
    stockWorkspaceDescription: 'Tylko do odczytu: stan operacyjny z niezmiennego ledgeru zapasów.',
    asOf: 'Stan na dzień',
    productSearch: 'Szukaj produktu',
    matrixOrientation: 'Orientacja macierzy',
    storesByProducts: 'Sklepy × produkty',
    productsByStores: 'Produkty × sklepy',
    resetOrder: 'Przywróć kolejność',
    storesCount: '{{count}} sklepów',
    productsCount: '{{count}} produktów',
    knownCells: '{{count}} znanych',
    incompleteCells: '{{count}} niepełnych',
    notInitializedCells: '{{count}} niezinicjowanych',
    notManagedCells: '{{count}} centralnych',
    lowCells: '{{count}} niskich',
    workspaceLoadFailed: 'Nie udało się wczytać statusu zapasów.',
    stockMatrix: 'Macierz zapasów',
    rowLabel: 'Sklep / produkt',
    notManaged: 'CENTRALA',
    notInitialized: 'NIEZNANY',
    notApplicable: 'Produkt nieaktywny dla tego sklepu',
    stockDrillDown: 'Szczegóły zapasu',
    goal: 'CEL',
    difference: 'Różnica',
    reorder: 'Zamówienie',
    provisional: 'tymczasowe',
    distributionMode: 'Tryb dystrybucji',
    ledgerExplanation: 'Wyjaśnienie ledgeru',
    stockState: {
      KNOWN: 'ZNANY',
      NOT_INITIALIZED: 'NIEZINICJOWANY',
      INCOMPLETE_DATA: 'NIEPEŁNE DANE',
      NOT_MANAGED: 'ZARZĄDZANE CENTRALNIE',
      NOT_APPLICABLE: 'NIEAKTYWNY DLA TEGO SKLEPU',
    },
  },
  sales: {
    title: 'Obszar sprzedaży',
    description:
      'Widok operacyjny tylko do odczytu dla potwierdzonych dziennych raportów sprzedaży.',
    datePreset: 'Zakres dat',
    from: 'Od',
    to: 'Do',
    network: 'Sieć',
    allNetworks: 'Wszystkie sieci',
    store: 'Sklep',
    allStores: 'Wszystkie sklepy',
    productSearch: 'Szukaj produktu',
    product: 'Produkt',
    allProducts: 'Wszystkie produkty',
    orientation: 'Układ macierzy',
    storesByProducts: 'Sklepy × produkty',
    productsByStores: 'Produkty × sklepy',
    knownSales: 'Znana sprzedaż',
    storesCount: 'Sklepy: {{count}}',
    productsCount: 'Aktywne produkty: {{count}}',
    reportDays: 'Potwierdzone dni raportowe: {{confirmed}} / {{expected}}',
    matrix: 'Macierz sprzedaży',
    rowLabel: 'Sklep / produkt',
    drillDown: 'Szczegóły komórki',
    date: 'Data',
    quantity: 'Ilość',
    coverageLabel: 'Pokrycie',
    known: 'Znane',
    knownZero: 'Znane zero',
    unknown: 'NIEZNANE',
    unknownCell: 'Brak danych ⚠',
    sum: 'SUMA',
    totalDrillDownHint: 'Pokaż gdzie i kiedy sprzedano',
    openTotalDrillDown: 'Pokaż sumę dla {{column}}',
    productSalesInPeriod: 'SPRZEDAŻ PRODUKTU W OKRESIE',
    storeSalesInPeriod: 'SPRZEDAŻ SKLEPU W OKRESIE',
    totalDetails: 'SZCZEGÓŁY',
    byStore: 'WG SKLEPU',
    byDay: 'WG DNIA',
    showZeros: 'Pokaż zera',
    hideZeros: 'Ukryj zera',
    share: 'Udział',
    storesWithSales: 'Sklepy ze sprzedażą',
    incompleteTotals: 'DANE NIEPEŁNE',
    incompleteTotalsDescription: 'Ranking i suma obejmują tylko znane potwierdzone ilości.',
    loadFailed: 'Nie udało się wczytać obszaru sprzedaży.',
    coverage: { COMPLETE: 'KOMPLETNE', INCOMPLETE_DATA: 'NIEKOMPLETNE DANE' },
    coverageDetailOpen: 'Otwórz status pokrycia sprzedaży',
    coverageDetailTitle: 'Status pokrycia danych',
    coverageDetailGoToImportCenter: 'Przejdź do Centrum importu',
    coverageDetailGroup: {
      missing: 'DO UZUPEŁNIENIA',
      ready: 'DO POTWIERDZENIA',
      needsFixing: 'WYMAGA NAPRAWY',
    },
    coverageDetailState: {
      NOT_UPLOADED: 'Brak raportu',
      PROCESSING: 'W trakcie',
      PREVIEW_READY: 'Gotowy do potwierdzenia',
      BLOCKED: 'Zablokowany',
      CONFLICT: 'Konflikt',
      FAILED: 'Błąd importu',
    },
    importConflictsOpen: 'Otwórz konflikty importu',
    importConflictsCount: 'KONFLIKTY IMPORTU: {{count}}',
    importConflictsTitle: 'KONFLIKTY IMPORTU',
    importConflictExistingConfirmed: 'Istniejący raport potwierdzony',
    compareConflict: 'Porównaj',
    importConflictAuthoritativeHint:
      'Potwierdzony raport pozostaje źródłem autorytatywnym do czasu jawnej decyzji.',
    quickPeriods: 'Szybkie okresy',
    weekPeriods: 'Tygodnie',
    isoYear: 'Rok',
    isoWeek: 'Tydzień',
    isoWeekOption: 'Tydzień {{week}} · {{range}}',
    notDue: 'Jeszcze nie wymagany',
    activeRange: '{{from}} – {{to}}',
    expandFilters: 'Pokaż filtry',
    collapseFilters: 'Zwiń filtry',
    columns: 'Kolumny',
    searchColumns: 'Szukaj kolumn',
    showAllColumns: 'Pokaż wszystkie',
    hideAllColumns: 'Ukryj wszystkie',
    allMatrixColumns: 'Wszystkie kolumny',
    visibleColumnsCount: 'Widoczne: {{visible}} / {{total}}',
    columnSearchResults: 'Wyniki wyszukiwania',
    showSearchResults: 'Pokaż wyniki wyszukiwania',
    hideSearchResults: 'Ukryj wyniki wyszukiwania',
    noColumnSearchResults: 'Brak pasujących kolumn',
    noProductsSelected: 'Nie wybrano produktów',
    noStoresSelected: 'Nie wybrano sklepów',
    pinColumn: 'Przypnij na początek',
    resetColumnLayout: 'Przywróć domyślny układ',
    resetRowOrder: 'Przywróć kolejność wierszy',
    pieceAbbreviation: 'szt.',
    kgAbbreviation: 'kg',
    preset: {
      '7d': '7 dni',
      '28d': '28 dni',
      '90d': '90 dni',
      ytd: 'YTD',
      last_confirmed_day: 'Ostatni dzień',
      last_2_confirmed_days: 'Ostatnie 2 dni',
      last_3_confirmed_days: 'Ostatnie 3 dni',
      last_7_calendar_days: 'Ostatnie 7 dni',
      last_completed_weekend: 'Ostatni weekend',
      current_week: 'Ten tydzień',
      previous_week: 'Poprzedni tydzień',
      iso_week: 'Wybierz tydzień',
      custom: 'Własny zakres',
    },
  },
  salesImports: {
    title: 'Raporty sprzedaży',
    description:
      'Wgrywanie, walidacja, potwierdzanie i rollback oficjalnych dziennych plików Sales Pivot.',
    upload: 'Wgraj skoroszyt',
    history: 'Historia importów',
    filename: 'Nazwa pliku',
    salesDate: 'Data sprzedaży',
    status: 'Status',
    statusValue: {
      UPLOADED: 'Wgrano',
      PROCESSING: 'W trakcie',
      PREVIEW_READY: 'Gotowy do potwierdzenia',
      BLOCKED: 'Zablokowany',
      DUPLICATE: 'Duplikat',
      DATE_CONFLICT: 'Konflikt danych',
      FAILED: 'Błąd importu',
      CONFIRMED: 'Potwierdzony',
      CANCELLED: 'Anulowany',
      ROLLED_BACK: 'Wycofany',
    },
    uploaded: 'Wgrano',
    stores: 'Sklepy',
    products: 'Produkty',
    nonzero: 'Niezerowe fakty',
    total: 'Łączna ilość',
    mappings: 'Mapowania i walidacja',
    issues: 'Uwagi walidacyjne',
    canonicalIdentityConflict:
      'Kilka tożsamości źródłowych wskazuje jeden canonical Product, ale nie można ich bezpiecznie zsumować.',
    canonicalizedProductsNotice:
      'Kilka zweryfikowanych tożsamości źródłowych zostało zsumowanych do produktu canonical. Każda komórka źródłowa pozostaje dostępna w audycie.',
    canonicalizedSourceCells: 'Scalone komórki źródłowe',
    sourceCell: 'Komórka źródłowa',
    sourceQuantity: 'Ilość źródłowa',
    nonRetailWarehouseDestination: 'Wykluczono — nierejestrowy odbiorca magazynowy',
    storeIdentityMissing: 'Zablokowano — brak tożsamości sklepu',
    distributionPolicyMissing: 'Brak polityki dystrybucji dla produktu {{sku}} {{product}}',
    fixDistributionPolicy: 'Napraw politykę',
    resolveStore: 'Dodaj lub połącz sklep',
    issueOccurrences: '{{count}} wystąpień',
    sample: 'Próbka po parsowaniu',
    confirm: 'Potwierdź oficjalny raport',
    revalidate: 'Sprawdź mapowania ponownie',
    retry: 'Ponów ze zapisanego źródła',
    rollback: 'Wycofaj raport',
    rollbackReason: 'Obowiązkowy powód rollbacku',
    detail: 'Szczegóły raportu',
    duplicate: 'Duplikat — te dane są już potwierdzone.',
    showExistingReport: 'Pokaż istniejący raport',
    conflict: 'Nowe źródło zawiera inne dane niż potwierdzony raport dla tej daty.',
    conflictComparisonTitle: 'Porównanie konfliktu importu',
    conflictComparisonDescription:
      'Porównaj potwierdzony raport z nowym źródłem. Zmiana danych wymaga jawnej decyzji.',
    existingConfirmedReport: 'OBECNY RAPORT — POTWIERDZONY',
    conflictingEvidence: 'NOWE ŹRÓDŁO — KONFLIKT',
    conflictScope: 'Sklepy: {{stores}} · Produkty: {{products}}',
    conflictDifferences: 'Zmienione pozycje sklep × produkt',
    store: 'Sklep',
    product: 'Produkt',
    existingValue: 'Obecnie',
    newValue: 'Nowa wartość',
    difference: 'Różnica',
    keepExistingReport: 'Zachowaj obecny raport',
    replaceWithNewReport: 'Zastąp raport nową wersją',
    replaceConfirm:
      'Zastąpić potwierdzony raport sprzedaży nową wersją? Poprzedni raport pozostanie zachowany jako historyczne źródło, a dane tego dnia zostaną przeliczone z nowego raportu.',
    replaceBack: 'Wróć',
    keepConfirm:
      'Zachowaj obecny potwierdzony raport jako autorytatywną prawdę Sprzedaży. Nowy plik pozostanie niezmiennym dowodem konfliktu.',
    conflictReason: 'Uzasadnienie decyzji',
    conflictReasonHelp:
      'Wymagane w audycie. Opisz, dlaczego raport pozostaje albo zostaje zastąpiony.',
    conflictAdminReason:
      'Tylko Administrator może podjąć tę audytowaną decyzję. Uzasadnienie jest obowiązkowe.',
    confirmConflictDecision: 'Potwierdź audytowaną decyzję',
    conflictStepExplain: 'Konflikt',
    conflictStepCompare: 'Porównanie',
    conflictStepDecision: 'Decyzja',
    conflictStepConfirm: 'Potwierdzenie',
    conflictRows_one: '{{count}} niezerowy wiersz',
    conflictRows_other: '{{count}} niezerowych wierszy',
    changeType: 'Zmiana',
    changeTypeValue: { ADDED: 'Dodano', REMOVED: 'Usunięto', CHANGED: 'Zmieniono' },
    conflictHelpTitle: 'Jak rozwiązać konflikt?',
    conflictHelpBody:
      'Porównaj źródło, osobę wgrywającą, czas, zakres, liczbę wierszy i każdą zmienioną wartość Sklep × Produkt. Zachowaj istniejący raport, gdy pozostaje autorytatywny. Zastąp go tylko wtedy, gdy nowe źródło jest poprawionym oficjalnym raportem; poprzedni raport pozostanie w historii.',
    conflictResolution: {
      KEEP_EXISTING: 'Konflikt przejrzany. Obecny potwierdzony raport pozostaje autorytatywny.',
      REPLACED: 'Nowa wersja raportu została potwierdzona. Poprzednia pozostaje w historii.',
    },
    completeZero:
      'Kompletny raport + brak faktu oznacza znane zero. Brak raportu oznacza wartość nieznaną.',
    choose: 'Wybierz skoroszyt Sales Pivot .xlsx',
    back: 'Wróć do historii importów',
    download: 'Pobierz oryginał',
    operationFailed: 'Nie udało się wykonać operacji importu sprzedaży.',
  },
  importCenter: {
    email: {
      source: 'E-mail',
      sourceFilter: 'Źródło',
      browserSource: 'Wgrane w przeglądarce',
      title: 'Import załączników e-mail',
      settings: 'Administracja e-mail',
      safety:
        'Odbiór e-maila tylko przygotowuje i waliduje załączniki. Potwierdzanie pozostaje ręczne; automat nie tworzy facts Sales, Shipment, inventory ani pipeline.',
      configured:
        'Konfiguracja aplikacji jest kompletna. Przed włączeniem osobno zweryfikuj DNS i rzeczywisty odbiór.',
      notConfigured:
        'Odbiór e-mail nie jest skonfigurowany. Adresy nie są aktywne. Skorzystaj z instrukcji aktywacji STAGING.',
      disabled: 'Odbiór e-mail jest wyłączony.',
      enabled: 'Włącz import załączników e-mail',
      addressMissing: 'Adres nieskonfigurowany',
      addressActive: 'Włączony w konfiguracji aplikacji',
      addressInactive: 'Nieaktywny — nie wysyłaj tu raportów',
      copyAddress: 'Kopiuj adres {{type}}',
      copied: 'Skopiowano adres.',
      copyFailed: 'Nie udało się skopiować. Zaznacz aktywny adres ręcznie.',
      authenticationPolicy:
        'Automatyczny import wymaga dozwolonego nadawcy i typu raportu oraz wyników SPF, DKIM i DMARC pass z Resend. Tylko jakub@kjotkompani.is może korzystać z zatwierdzonego wyjątku DKIM gray przy SPF i DMARC pass; DKIM fail lub unknown nigdy nie jest akceptowany. Inne niepewne wyniki oznaczają kwarantannę. Potwierdzenie raportu pozostaje ręczne.',
      autoReleaseEnabled:
        'Automatycznie importuj uwierzytelnione wiadomości od dozwolonych nadawców',
      providerVerified:
        'Zwolniono automatycznie zgodnie z zatwierdzoną polityką uwierzytelniania nadawcy na podstawie wyników Resend. Potwierdzenie raportu pozostaje ręczne.',
      senders: 'Dozwoleni nadawcy i typy raportów',
      senderAddress: 'E-mail nadawcy',
      addSender: 'Dodaj nadawcę',
      removeSender: 'Usuń nadawcę',
      limits:
        'Limity: {{attachments}} załączników; {{fileBytes}} bajtów na plik; {{totalBytes}} bajtów na wiadomość.',
      reason: 'Uzasadnienie audytowe',
      reasonHint: 'Co najmniej 10 znaków. Bez sekretów i treści wiadomości.',
      actionFailed:
        'Nie przyjęto operacji. Sprawdź konfigurację, uprawnienia nadawcy, bieżący stan i limit prób, a następnie odśwież.',
      settingsFailed: 'Nie udało się wczytać konfiguracji e-mail.',
      cancel: 'Anuluj',
      save: 'Zapisz ustawienia',
      proceed: 'Kontynuuj',
      refresh: 'Odśwież',
      empty: 'Brak odebranych źródeł e-mail dla tego filtra.',
      typeUnresolved: 'Typ raportu nieustalony',
      counts:
        'Załączniki {{total}} · przetworzone {{processed}} · pominięte {{skipped}} · błędne {{failed}} · oczekujące {{pending}}',
      adminApproved: 'Administrator zweryfikował dowody nadawcy i dopuścił wiadomość.',
      unverified: 'Uwierzytelnienie nadawcy niezweryfikowane.',
      release: 'Sprawdź / dopuść z kwarantanny',
      retry: 'Ponów niedokończone załączniki',
      attachments: 'Załączniki i pochodzenie ({{total}})',
      identifiers: 'E-mail dostawcy: {{provider}} · Message-ID: {{messageId}}',
      attachmentMeta: '{{size}} bajtów · próby {{attempts}}',
      unknown: 'Nieznane',
      pendingHash: 'Jeszcze niezapisany',
      provenance:
        'Załącznik dostawcy: {{attachment}} · import_file: {{file}} · element paczki: {{item}}',
      reviewReport: 'Sprawdź walidację / raport',
      releaseWarning:
        'Przed dopuszczeniem niezależnie zweryfikuj nadawcę. Nadawca i typ raportu muszą pozostać dozwoleni. Operacja pozwala tylko na staging, nigdy na potwierdzenie.',
      retryWarning:
        'Ponawiana jest tylko praca niedokończona lub błędna, w granicach limitu prób serwera. Zakończone załączniki i dowody biznesowe nie są dublowane.',
      statusRECEIVED: 'Odebrano',
      statusPROCESSING: 'Przetwarzanie',
      statusQUARANTINED: 'Kwarantanna',
      statusREADY: 'Gotowe do ręcznego potwierdzenia',
      statusBLOCKED: 'Blokada walidacji',
      statusDUPLICATE: 'Duplikat',
      statusCOMPLETED_WITH_ERRORS: 'Zakończono z błędami',
      statusFAILED: 'Błąd',
      statusPENDING: 'Oczekuje',
      statusSKIPPED: 'Pominięto',
      statusCOMPLETED: 'Zakończono',
      statusCONFIRMED: 'Potwierdzono ręcznie',
      statusCANCELLED: 'Anulowano',
      statusROLLED_BACK: 'Wycofano',
      pageSummary: 'Wiadomości {{from}}–{{to}} z {{total}}',
      previousPage: 'Poprzednie wiadomości',
      nextPage: 'Następne wiadomości',
      reasonAuthentication:
        'Niezależnie zweryfikuj nadawcę, a następnie poproś Administratora o dopuszczenie.',
      reasonSender:
        'Nadawca lub typ raportu nie jest dozwolony. Sprawdź listę w panelu Administratora.',
      reasonRecipient:
        'Odbiorca nie wskazuje jednoznacznie typu raportu. Użyj jednego skonfigurowanego adresu odbiorczego.',
      reasonUnsupported: 'Pominięto nieobsługiwany załącznik; pozostałe są dalej przetwarzane.',
      reasonLimit: 'Przekroczono limit bezpieczeństwa pliku, wiadomości lub skoroszytu.',
      reasonWorkbook:
        'Załącznik nie jest prawidłowym obsługiwanym skoroszytem XLSX. Poproś o poprawione źródło.',
      reasonUnsafe:
        'Odrzucono szyfrowaną, wykonywalną, zawierającą formuły lub inną niebezpieczną zawartość skoroszytu.',
      reasonValidation:
        'Istniejący parser raportu odrzucił źródło. Sprawdź walidację przed ponowieniem.',
      reasonTechnical:
        'Przetwarzanie wymaga uwagi. Zachowaj źródło i zgłoś kod diagnostyczny, jeśli ponowienie się nie powiedzie.',
    },
    title: 'Centrum importu',
    description: 'Operacyjna skrzynka raportów Sprzedaży i Wysyłek.',
    loading: 'Ładowanie importów…',
    loadFailed: 'Nie udało się wczytać Centrum importu.',
    dateUnknown: 'Data oczekuje na walidację',
    scopeUnknown: 'Zakres oczekuje na walidację',
    openBatch: 'Otwórz partię',
    backToInbox: 'Wróć do skrzynki',
    salesBatch: 'Partia Sprzedaży',
    shipmentBatch: 'Partia Wysyłek',
    batchItems: 'Pliki w partii',
    businessDates_one: '{{count}} dzień raportowy',
    businessDates_other: '{{count}} dni raportowych',
    confirmAllSafety: 'Potwierdzane są wyłącznie raporty spełniające istniejące reguły domenowe.',
    confirmResult:
      'Potwierdzono {{confirmed}}; już potwierdzone {{already_confirmed}}; zablokowane {{blocked}}; błędy {{failed}}.',
    tabs: {
      label: 'Sekcje Centrum importu',
      actions: 'Wymaga działania',
      missing: 'Brakujące raporty',
      history: 'Historia',
      upload: 'Wgraj wiele plików',
    },
    filters: {
      from: 'Od',
      to: 'Do',
      type: 'Typ',
      all: 'Wszystkie',
      network: 'Sieć',
      store: 'Sklep',
      search: 'Nazwa pliku, data lub identyfikator',
      filename: 'Nazwa pliku',
      reportDate: 'Data raportu',
      status: 'Status',
      sort: 'Sortowanie',
      ascending: 'Rosnąco',
      descending: 'Malejąco',
      showTestData: 'Pokaż dane testowe',
    },
    columns: {
      report: 'Raport',
      source: 'Źródło',
      scope: 'Zakres',
      reason: 'Powód',
      counts: 'Wiersze',
      quantity: 'Ilość',
      action: 'Działanie',
      date: 'Data',
      type: 'Typ',
      deadline: 'Oczekiwany do',
      state: 'Stan',
      uploader: 'Wgrał',
      identifier: 'Identyfikator',
    },
    actions: {
      title: 'Raporty wymagające działania',
      previousStatus: 'Poprzedni raport: {{status}}',
      rows: '{{count}} wierszy',
      valid: '{{count}} poprawnych',
      errors: '{{count}} błędów',
      unrecognized: '{{count}} nierozpoznanych',
      emptyTitle: 'Brak zadań',
      emptyBody: 'Żaden import nie wymaga teraz działania.',
      retry: 'Ponów',
      viewIssues: 'Zobacz problemy',
      preview: 'Podgląd / potwierdź',
      openReport: 'Otwórz raport',
      processing: 'Przetwarzanie',
      confirmAll: 'Potwierdź wszystkie gotowe',
      recalculateBatchStatus: 'Przelicz status partii',
      revalidate: 'Waliduj ponownie',
      revalidateBackfill: 'Waliduj daty ponownie',
    },
    statusReconciliation: {
      title: 'Przelicz status partii',
      loading: 'Sprawdzanie stanu domenowego…',
      safety:
        'Operacja synchronizuje wyłącznie status operacyjny pliku z już potwierdzonym raportem. Nie uruchamia parsera, walidacji ani potwierdzenia i nie zmienia raportów ani faktów.',
      current: 'Obecnie: {{status}}',
      expected: 'Po naprawie: {{status}}',
      eligible: 'Do synchronizacji: {{count}}',
      excluded: 'Poza zakresem: {{count}}',
      currentState: 'Status pliku',
      authoritativeState: 'Status raportu',
      scope: 'Zakres naprawy',
      included: 'Objęty naprawą',
      exclusionITEM_NOT_PREVIEW_READY: 'Status pliku nie kwalifikuje się',
      exclusionDOMAIN_BATCH_MISSING: 'Brak powiązanego raportu domenowego',
      exclusionDOMAIN_BATCH_NOT_CONFIRMED: 'Raport domenowy nie jest potwierdzony',
      noDrift: 'Statusy tej partii są już zgodne.',
      zeroEffects: 'Raporty, fakty, zdarzenia potwierdzenia, mapowania i polityki: 0 zmian.',
      reason: 'Obowiązkowe uzasadnienie',
      reasonHelp: 'Aktor, czas oraz dokładny stan przed i po zostaną zapisane w audycie.',
      confirmation: 'Wpisz {{value}}',
      cancel: 'Anuluj',
      apply: 'Przelicz status',
      saving: 'Zapisywanie…',
      previewFailed: 'Nie udało się przygotować podglądu. Odśwież partię i spróbuj ponownie.',
      failed: 'Stan zmienił się lub synchronizacja nie powiodła się. Niczego nie zapisano.',
      success: 'Zsynchronizowano {{count}} plików. Status partii: {{status}}.',
    },
    conflicts: {
      title: 'Konflikty importu',
      description: 'Porównanie nowych źródeł z aktywnymi potwierdzonymi raportami.',
      grouping: 'Grupowanie konfliktów',
      groupByReport: 'Według raportu',
      groupBySourceUpload: 'Według źródłowego uploadu',
      sourceCardLabel: 'Konflikty z pliku {{filename}}',
      sourceUploadedBy: 'Wgrał: {{uploader}} · {{date}}',
      sourceDateRange: 'Zakres dat: {{from}}–{{to}}',
      sourceConfirmed: 'Potwierdzone partycje: {{count}} · fakty: {{facts}}',
      sourceConflicts: 'Konflikty do zamknięcia: {{count}}',
      sourceConflictBreakdown: 'Różnice: {{material}} · zablokowane: {{blocked}}',
      sourceOtherBlocked: 'Pozostałe zablokowane partycje: {{count}}',
      sourceKeepEffect:
        'Zachowuje oficjalne raporty. Nie zmienia potwierdzonych danych ani pozostałych zablokowanych partycji tego uploadu.',
      closeSourceConflicts: 'Zachowaj oficjalne i zamknij {{count}} konfliktów tego uploadu',
      sourceEmptyTitle: 'Brak uploadów z otwartymi konfliktami',
      sourceEmptyBody: 'Żaden źródłowy upload nie zawiera konfliktów wymagających zamknięcia.',
      sourceKeepTitle: 'Zachowaj oficjalne raporty dla źródłowego uploadu',
      sourcePreservedEvidence:
        'Plik, dane źródłowe, issues oraz istniejące potwierdzone raporty pozostają zachowane.',
      sourceEvidenceDifferences:
        'Różnice w zamykanym źródle — wyłącznie informacyjne, nie zostaną zapisane jako fakty',
      sourceExpectedEffects:
        'Skutek operacji: raporty Sales {{reports}}, fakty Sales {{facts}}, potwierdzenia {{confirmations}}, mapowania {{mappings}}, polityki {{policies}}, rewalidacje {{revalidations}}.',
      total: 'Razem: {{count}}',
      materialCount: 'Różnice biznesowe: {{count}}',
      blockedCount: 'Zablokowane: {{count}}',
      classification: 'Klasyfikacja',
      classificationEXACT_DUPLICATE: 'Dokładny duplikat',
      classificationMETADATA_ONLY: 'Tylko metadane',
      classificationMATERIAL_DIFFERENCE: 'Różnica biznesowa',
      classificationBLOCKED: 'Zablokowany',
      existingReport: 'Istniejący raport',
      newReport: 'Nowy raport',
      changed: 'Zmienione',
      added: 'Dodane',
      removed: 'Usunięte',
      negatives: 'Ujemne',
      recommendation: 'Rekomendacja',
      recommendationKEEP_EXISTING: 'Zachowaj istniejący',
      recommendationCOMPARE: 'Porównaj i zdecyduj',
      recommendationRESOLVE_BLOCKERS: 'Najpierw usuń blokery',
      compare: 'Porównaj',
      openFullComparison: 'Pełne porównanie',
      factCount: '{{count}} pozycji',
      selectPage: 'Zaznacz bieżącą stronę',
      clearPage: 'Odznacz bieżącą stronę',
      selectAllResults: 'Zaznacz wszystkie wyniki',
      clearAll: 'Odznacz wszystkie',
      selectedCount: 'Wybrano: {{count}}',
      selectReport: 'Zaznacz raport z dnia {{date}}',
      allFilteredSelected: 'Wybrano wszystkie niezablokowane wyniki aktualnego filtra.',
      keepExisting: 'Zachowaj istniejące',
      replaceWithNew: 'Zastąp nowymi',
      keepTitle: 'Zachowaj istniejące raporty',
      replaceTitle: 'Zastąp aktywne raporty nowymi',
      previewCounts: 'Do wykonania: {{eligible}} · wykluczone: {{excluded}}',
      excludedReports: 'Raporty wykluczone i przyczyny',
      reason: 'Obowiązkowe wspólne uzasadnienie',
      confirmationText: 'Wpisz {{value}}',
      acceptNegatives: 'Akceptuję {{count}} ujemnych korekt w nowych raportach',
      cancel: 'Anuluj',
      execute: 'Wykonaj',
      executing: 'Wykonywanie…',
      operationFailed: 'Nie udało się przygotować lub wykonać operacji. Odśwież porównanie.',
      retryIncomplete: 'Ponów nieukończone',
      partitionResults: 'Wyniki partycji ({{count}})',
      partitionResultsLabel: 'Wyniki operacji dla partycji źródłowych',
      partitionResult: 'Wynik',
      none: 'Brak',
      operationStatus:
        '{{status}} · wykonane {{completed}} · pominięte {{skipped}} · błędy {{failed}}',
      operationStatusPENDING: 'Oczekuje',
      operationStatusRUNNING: 'W toku',
      operationStatusPARTIAL: 'Częściowo zakończona',
      operationStatusCOMPLETED: 'Zakończona',
      operationStatusSKIPPED: 'Pominięta',
      operationStatusFAILED: 'Nieudana',
      guardTEST_FIXTURE: 'Dane testowe są wykluczone',
      guardNOT_MATERIAL_DIFFERENCE: 'Raport nie zawiera różnicy biznesowej',
      guardUNIT_MISMATCH: 'Jednostki raportów są niezgodne',
      guardUNKNOWN_UNIT: 'Raport zawiera nieobsługiwaną jednostkę',
      guardACTIVE_REPORT_COUNT_CHANGED: 'Liczba aktywnych raportów uległa zmianie',
      guardPARALLEL_CONFLICT: 'Dla tej daty istnieje więcej niż jeden konflikt',
      guardSEMANTIC_HASH_MISSING: 'Brakuje kompletnego odcisku danych raportu',
      guardSOURCE_EVIDENCE_MISSING: 'Brakuje niezmiennego powiązania ze źródłowym uploadem',
      guardSOURCE_EVIDENCE_MISMATCH: 'Niezmienny dowód źródłowego uploadu nie jest już zgodny',
      guardAUTHORITATIVE_REPORT_NOT_CONFIRMED:
        'Raport wskazany jako oficjalny nie jest już potwierdzony',
      guardIMPORT_CONFLICT_STATE_CHANGED:
        'Stan raportu lub dowodu źródłowego zmienił się od podglądu',
      guardIMPORT_CONFLICT_OPERATION_FAILED:
        'Nie udało się zamknąć tej partycji; można bezpiecznie ponowić nieukończone pozycje',
      guardSHIPMENT_RECONCILIATION_REQUIRED: 'Wysyłka wymaga zakończenia rekonsyliacji',
      guardSHIPMENT_PARTIAL_RANGE_REPLACE_UNSAFE:
        'Krótsze źródło nie może zastąpić całego potwierdzonego raportu wysyłek',
      emptyTitle: 'Brak otwartych konfliktów',
      emptyBody: 'Żaden raport nie wymaga porównania z potwierdzonym raportem.',
    },
    incompleteSource: {
      title: 'Odrzuć niekompletne części źródła',
      selectedCount: 'Wybrane niekompletne części: {{count}}',
      selectEligible: 'Wybierz kwalifikujące się na tej stronie',
      clearSelection: 'Wyczyść wybór',
      previewAction: 'Podgląd odrzucenia',
      preparing: 'Przygotowywanie podglądu…',
      previewFailed: 'Nie udało się przygotować podglądu. Odśwież skrzynkę i spróbuj ponownie.',
      selectPartition: 'Wybierz niekompletną część z pliku {{filename}}',
      select: 'Wybierz do odrzucenia',
      previewCounts:
        'Wybrano: {{selected}} · kwalifikuje się: {{eligible}} · wykluczono: {{excluded}}',
      eligible: 'Kwalifikuje się',
      excluded: 'Wykluczono',
      blockers: 'Blokujące dane źródłowe',
      unknownBlocker: 'Nierozwiązany problem blokujący',
      quantityTotals: 'Niezerowe ilości w źródle',
      entityCounts: 'Placówki: {{stores}} · Produkty: {{products}}',
      sourceRows: 'Niezerowe komórki źródła: {{cells}} · wiersze {{first}}–{{last}}',
      blankStoreEvidence: 'Dowód pustej placówki: {{count}} niezmapowanych kolumn źródła',
      currentEffects:
        'Aktualne skutki biznesowe — raporty: {{reports}} · fakty: {{facts}} · aktywne potwierdzone raporty: {{confirmed}}',
      sharedSource:
        'Wspólne źródło — części: {{partitions}} · potwierdzone: {{confirmed}} · duplikaty: {{duplicates}} · potwierdzone fakty: {{facts}}',
      exclusionReasons: 'Nie można odrzucić',
      notEligible: 'Ta część nie kwalifikuje się już do operacji',
      effect:
        'Części zmienione na ANULOWANE: {{count}}. Raporty Sales: {{reports}}; fakty Sales: {{facts}}. Operacja nie zmieni mapowań ani wspólnego pliku, nie potwierdzi i nie usunie danych oraz nie uruchomi ponownej walidacji. Pokrycie każdej daty pozostanie BRAKUJĄCE (nieznane), nigdy zero.',
      reason: 'Obowiązkowy powód odrzucenia',
      reasonHelp: 'Powód zostanie zapisany w niezmiennym śladzie audytowym.',
      confirmationText: 'Wpisz dokładnie: {{value}}',
      confirmationHelp: 'Tekst musi być identyczny z tekstem w podglądzie serwera.',
      reject: 'Odrzuć niekompletne źródło',
      rejecting: 'Odrzucanie…',
      cancel: 'Anuluj',
      close: 'Zamknij',
      operationFailed:
        'Nie udało się odrzucić niekompletnego źródła. Odśwież skrzynkę i przygotuj nowy podgląd.',
      operationId: 'Identyfikator operacji: {{operationId}}',
      replayed: 'Powtórzenie idempotentne',
      result: '{{status}} · wykonano {{completed}} · pominięto {{skipped}} · błędy {{failed}}',
      resultsLabel: 'Wyniki odrzucenia niekompletnego źródła',
      resultStatusCOMPLETED: 'Zakończono',
      resultStatusPARTIAL: 'Zakończono częściowo',
      resultStatusFAILED: 'Niepowodzenie',
      outcomeStatusCOMPLETED: 'Anulowano',
      outcomeStatusSKIPPED: 'Pominięto',
      outcomeStatusFAILED: 'Niepowodzenie',
      none: 'Brak',
      partitionFailed: 'Nie udało się odrzucić tej części',
      errorCodeIMPORT_INCOMPLETE_SOURCE_STATE_CHANGED: 'Dane źródłowe zmieniły się po podglądzie',
      errorCodeIMPORT_INCOMPLETE_SOURCE_NOT_REJECTABLE:
        'Ta część nie kwalifikuje się już do operacji',
      errorCodeIMPORT_INCOMPLETE_SOURCE_PREVIEW_MISMATCH: 'Podgląd nie odpowiada już żądaniu',
      errorCodeIMPORT_INCOMPLETE_SOURCE_CONFIRMATION_MISMATCH: 'Tekst potwierdzenia jest niezgodny',
      guardIMPORT_TYPE_NOT_SUPPORTED: 'Obsługiwane są tylko części Sales',
      guardSTATUS_NOT_BLOCKED: 'Ta część nie jest już zablokowana',
      guardSOURCE_PARTITION_MISSING: 'Brakuje niezmiennych danych części źródła',
      guardALREADY_CONFIRMED: 'Ta część została już potwierdzona',
      guardIS_DUPLICATE: 'Ta część jest duplikatem',
      guardIS_CONFLICT: 'Ta część ma konflikt importu',
      guardHAS_BUSINESS_EFFECT: 'Ta część ma już skutek biznesowy',
      guardDATE_ALREADY_CONFIRMED: 'Dla tej daty istnieje już potwierdzony raport',
      guardIS_DUPLICATE_CANONICAL: 'Inny import wskazuje tę część jako źródło duplikatu',
      guardHAS_CONFLICT_RESOLUTION: 'Dla tej części istnieje już decyzja konfliktowa',
      guardTEST_DATA_USES_SEPARATE_WORKFLOW: 'Dane testowe korzystają z osobnego procesu',
      guardNO_BLOCKING_ISSUE: 'Nie pozostał żaden problem blokujący',
      guardNO_EMPTY_UNKNOWN_STORE_EVIDENCE: 'Nie znaleziono blokady pustej, nieznanej placówki',
      guardNO_EMPTY_UNMAPPED_STORE_EVIDENCE: 'Nie znaleziono pustej, niezmapowanej placówki',
      guardHAS_ADDITIONAL_BLOCKING_ISSUES:
        'Partycja ma dodatkowe problemy blokujące i wymaga osobnej decyzji',
      guardHAS_NON_EMPTY_OR_MAPPED_STORE_EVIDENCE:
        'Partycja zawiera rozpoznaną albo niepustą placówkę i nie może zostać odrzucona w całości',
      guardNO_FRAGMENTARY_ROWS: 'Nie znaleziono niezerowych fragmentarycznych wierszy źródła',
    },
    productIssues: {
      title: 'Wspólne problemy',
      description:
        'Jedna decyzja mapowania może odblokować wszystkie niepotwierdzone raporty z tym samym kodem źródłowym.',
      sourceSku: 'Kod źródłowy',
      sourceNames: 'Nazwa ze źródła',
      affectedReports: 'Raporty objęte zmianą',
      reportCount_one: '{{count}} raport',
      reportCount_other: '{{count}} raportów',
      dateRange: 'Zakres dat',
      occurrences: 'Wystąpienia',
      resolve: 'Rozwiąż',
      openCommonIssue: 'Otwórz wspólny problem',
      adminRequired: 'Wymagany Administrator',
      resolveTitle: 'Rozwiąż nieznany produkt {{sku}}',
      sourceAttributesUnavailable:
        'Plik Sales Pivot nie dostarcza autorytatywnej jednostki ani masy netto. Przy tworzeniu produktu wybierz je jawnie — system ich nie zgaduje.',
      examples: 'Przykłady ze źródła',
      matchExisting: 'Dopasuj do istniejącego produktu',
      searchProducts: 'Szukaj po SKU, nazwie lub aliasie',
      decisionPreview: 'Podgląd decyzji i aliasu',
      canonicalAttributes: 'Jednostka: {{unit}} · Masa netto: {{weight}}',
      notSet: 'nie ustawiono',
      existingAliases_one: 'Produkt ma {{count}} istniejący alias.',
      existingAliases_other: 'Produkt ma {{count}} istniejących aliasów.',
      reason: 'Uzasadnienie decyzji',
      reasonHelp: 'Powód zostanie zapisany w audycie i pochodzeniu aliasu.',
      resolveFailed: 'Nie udało się zapisać decyzji i ponownie zwalidować raportów.',
      technicalDetail: 'Szczegół techniczny: {{code}}',
      resultSummary:
        'Zapisano mapowanie. Razem {{total}}, gotowe {{ready}}, nadal zablokowane {{blocked}}, błędy ponownej walidacji {{failed}}.',
      previousAliases_one: 'Znaleziono {{count}} wcześniejszy alias dla tego kodu źródłowego.',
      previousAliases_other:
        'Znaleziono {{count}} wcześniejszych aliasów dla tego kodu źródłowego.',
      active: 'aktywny',
      leaveUnresolved: 'Pozostaw nierozwiązany',
      createNew: 'Utwórz nowy produkt',
      resolving: 'Zapisywanie i walidacja…',
      retryFailed: 'Ponów błędne walidacje',
      retrying: 'Ponawianie walidacji…',
      matchAndRevalidate: 'Dopasuj i waliduj raporty',
    },
    storeIssues: {
      title: 'Nowe sklepy i produkty — sklepy',
      description:
        'Jedna jawna decyzja może połączyć źródłową nazwę sklepu ze Store lub utworzyć nowy Store bez zgadywania sieci.',
      sourceIdentity: 'Nazwa sklepu ze źródła',
      type: 'Typ importu',
      affectedReports: 'Raporty objęte zmianą',
      dateRange: 'Zakres dat',
      candidates: 'Możliwe istniejące sklepy',
      noCandidates: 'Brak bezpiecznego kandydata',
      resolve: 'Dodaj lub połącz sklep',
      resolveTitle: 'Rozwiąż sklep {{name}}',
      noAutomaticMatch:
        'System nie przełączy sklepu ani sieci automatycznie. Kandydaci są wyłącznie informacją do jawnej decyzji.',
      reportCount_one: '{{count}} raport',
      reportCount_other: '{{count}} raportów',
      occurrenceCount_one: '{{count}} wystąpienie',
      occurrenceCount_other: '{{count}} wystąpień',
      reports: 'Raporty i daty',
      examples: 'Przykładowe pozycje źródłowe',
      matchExisting: 'Połącz z istniejącym sklepem',
      createNew: 'Dodaj nowy sklep',
      searchStores: 'Szukaj sklepu po nazwie lub sieci',
      canonicalName: 'Nazwa kanoniczna sklepu',
      shortName: 'Krótka nazwa (opcjonalnie)',
      network: 'Sieć',
      networkRequired: 'Sieć musi zostać wybrana jawnie.',
      manageNetworks: 'Otwórz katalog sieci',
      activityDateSeparate:
        'Pierwsze wystąpienie w raporcie ustala datę aliasu, ale nie jest dowodem daty otwarcia sklepu.',
      effectiveFrom: 'Alias obowiązuje od',
      effectiveTo: 'Alias obowiązuje do (wyłącznie, opcjonalnie)',
      aliasDateHelp:
        'Zakres dotyczy wyłącznie mapowania nazwy źródłowej. Nie zmienia historycznej aktywności sklepu.',
      reason: 'Obowiązkowe uzasadnienie decyzji',
      reasonHelp: 'Aktor, decyzja, Store, sieć i alias zostaną zapisane w audycie.',
      resolveFailed: 'Nie udało się zapisać decyzji lub ponownie zwalidować raportów.',
      resultSummary:
        'Zapisano mapowanie. Razem {{total}}, gotowe {{ready}}, nadal zablokowane {{blocked}}, błędy {{failed}}.',
      leaveUnresolved: 'Pozostaw nierozwiązany',
      saveAndRevalidate: 'Zapisz i sprawdź raport',
      revalidating: 'Zapisywanie i walidacja…',
      retry: 'Wznów nieudaną walidację',
      locationOnlyWarning:
        '{{store}} ({{network}}) ma podobną lokalizację, ale nie jest automatycznie tym samym sklepem.',
      matchBasis_EXACT_CANONICAL: 'dokładna nazwa kanoniczna',
      matchBasis_EXACT_ALIAS: 'dokładny istniejący alias',
      matchBasis_LOCATION_TOKEN: 'podobna nazwa lokalizacji — wymaga weryfikacji',
    },
    distributionIssues: {
      title: 'Brak polityki dystrybucji',
      summary: 'Brak polityki dystrybucji: {{products}} produktów · {{reports}} raportów',
      product: 'Produkt',
      sourceSku: 'Kod źródłowy',
      sourceName: 'Nazwa źródłowa',
      sourceNames: 'Nazwy w źródle',
      scope: 'Zakres',
      dateRange: 'Daty raportów',
      counts: 'Wystąpienia',
      currentPolicies: 'Aktualne polityki',
      noPolicies: 'Brak',
      fixPolicy: 'Napraw politykę',
      resolveTitle: 'Ustaw politykę dystrybucji',
      explanation:
        'Brak polityki dystrybucji dla produktu {{sku}} {{product}} w sieci {{network}}. Obecność produktu w raporcie nie jest zgodą na utworzenie polityki.',
      reportCount_one: '{{count}} raport',
      reportCount_other: '{{count}} raportów',
      occurrenceCount_one: '{{count}} wystąpienie',
      occurrenceCount_other: '{{count}} wystąpień',
      action: 'Sposób naprawy',
      actionCreate: 'Utwórz nową politykę',
      actionExtend: 'Rozszerz aktualną politykę',
      actionLink: 'Połącz z istniejącą polityką',
      existingPolicy: 'Istniejąca polityka',
      wholeNetwork: 'Cała sieć',
      selectedStores: 'Wybrane sklepy',
      affectedStores: 'Sklepy wskazane przez raporty',
      mode: 'Model dystrybucji',
      modeDirect: 'Bezpośrednio do sklepów',
      modeCentral: 'Sprzedaż przez magazyn centralny',
      effectiveFrom: 'Obowiązuje od',
      effectiveTo: 'Obowiązuje do (wyłącznie)',
      reason: 'Obowiązkowe uzasadnienie',
      reasonHelp: 'Decyzja, poprzedni stan i aktor zostaną zapisani w audycie.',
      previewTitle: 'Raporty do ponownej walidacji: {{count}}',
      resolveFailed: 'Nie udało się zapisać polityki lub ponownie zwalidować raportów.',
      result:
        'Walidacja zakończona: razem {{total}}, gotowe {{ready}}, nadal zablokowane {{blocked}}, błędy {{failed}}.',
      leaveUnresolved: 'Pozostaw nierozwiązany',
      saveAndRevalidate: 'Zapisz i waliduj raporty',
      revalidating: 'Zapisywanie i walidacja…',
      retry: 'Wznów nieudaną walidację',
      scopeKindNETWORK: 'cała sieć',
      scopeKindSTORES: 'wybrane sklepy',
    },
    missing: {
      title: 'Brakujące raporty',
      daysLate_one: '{{count}} dzień opóźnienia',
      daysLate_few: '{{count}} dni opóźnienia',
      daysLate_many: '{{count}} dni opóźnienia',
      daysLate_other: '{{count}} dni opóźnienia',
      hoursLate: '{{count}} godz. opóźnienia',
      shipmentScheduleUnavailable:
        'Sprzedaż korzysta z autorytatywnego harmonogramu dziennego. Brak harmonogramu dostaw Wysyłek, dlatego system nie wymyśla ich braków.',
      exportCsv: 'Eksportuj CSV',
      activeScope: '{{stores}} aktywnych sklepów · {{networks}} sieci',
      dailySchedule: 'Dzienny harmonogram Sprzedaży',
      openImport: 'Otwórz import',
      openCommonIssue: 'Napraw wspólny problem',
      upload: 'Wgraj raport',
      emptyTitle: 'Brak brakujących raportów',
      emptyBody: 'Każdy oczekiwany dzień Sprzedaży w tym zakresie ma potwierdzony raport.',
    },
    missingState: {
      EXPECTED_TODAY: 'Oczekiwany dzisiaj',
      OVERDUE: 'Po terminie',
      IN_PROGRESS: 'Import w toku',
    },
    history: {
      title: 'Historia importów',
      open: 'Otwórz',
      markTestData: 'Oznacz jako dane testowe',
      markTestDataTitle: 'Oznacz historyczny import jako dane testowe',
      markingTestData: 'Oznaczanie…',
      testDataLabel: 'Etykieta danych testowych',
      testDataLabelHelp: 'Etykieta musi zaczynać się od „STAGING TEST”.',
      testDataReason: 'Uzasadnienie',
      markerKeepsStatus:
        'Ta operacja tylko doda niezmienny marker danych testowych. Status widoczny: {{displayStatus}}; status domenowy: {{domainStatus}}. Raporty, fakty i historia nie zostaną zmienione.',
      domainStatus: 'Status domenowy: {{status}}',
      dispositionIncompleteSourceRejected: 'Odrzucono — niepełne źródło',
      rejectionReason: 'Powód: {{reason}}',
      markTestDataFailed: 'Nie udało się oznaczyć importu jako danych testowych.',
      markTestDataSuccess: 'Import oznaczono jako dane testowe bez zmiany jego historii.',
      cancel: 'Anuluj',
      emptyTitle: 'Brak historii',
      emptyBody: 'Brak raportów pasujących do filtrów.',
    },
    recommended: {
      COMPARE_AND_RESOLVE: 'Porównaj i rozstrzygnij',
      RETRY_OR_REUPLOAD: 'Ponów / sprawdź',
      FIX_MAPPINGS_AND_REVALIDATE: 'Napraw i waliduj',
    },
    status: {
      QUEUED: 'W kolejce',
      UPLOADED: 'Wgrany',
      PARSING: 'Odczytywanie',
      PROCESSING: 'Przetwarzanie',
      PREVIEW_READY: 'Gotowy do potwierdzenia',
      READY: 'Gotowy',
      BLOCKED: 'Zablokowany',
      DUPLICATE: 'Duplikat',
      DATE_CONFLICT: 'Konflikt',
      CONFLICT: 'Konflikt',
      FAILED: 'Błąd importu',
      CONFIRMED: 'Potwierdzony',
      COMPLETED: 'Zakończona',
      COMPLETED_WITH_ERRORS: 'Zakończona z problemami',
      REVIEW_REQUIRED: 'Wymaga przeglądu',
      CANCELLED: 'Anulowany',
      INCOMPLETE_SOURCE_REJECTED: 'Odrzucono — niepełne źródło',
      REVALIDATION_FAILED: 'Błąd ponownej walidacji',
      ROLLED_BACK: 'Wycofany',
      REJECTED: 'Odrzucony',
      SUPERSEDED: 'Zastąpiony',
      OVERLAP: 'Nakładanie — zachowano istniejący',
      NOT_UPLOADED: 'Brak raportu',
    },
    reason: {
      BULK_IMPORT_PROCESSING_FAILED: 'Przetwarzanie nie powiodło się',
      SHIPMENT_INVOICE_NUMBER_REQUIRED: 'W wierszu wysyłki brakuje numeru faktury.',
      SHIPMENT_INVOICE_NUMBER_UNSAFE_NUMERIC:
        'Numer faktury został zapisany w Excelu jako niebezpieczna liczba i mógł utracić cyfry. Ustaw kolumnę Invoice # jako Tekst i ponownie wpisz oryginalny numer.',
      SHIPMENT_INVOICE_NUMBER_INVALID:
        'Numer faktury ma nieobsługiwany typ lub format. Ustaw kolumnę Invoice # jako Tekst.',
      SHIPMENT_INVOICE_NUMBER_TOO_LONG: 'Numer faktury przekracza limit 128 znaków.',
      DATE_CONFLICT: 'Potwierdzony raport zawiera inne dane',
      UNKNOWN_STORE: 'Nieznany sklep',
      AMBIGUOUS_STORE: 'Niejednoznaczny sklep',
      UNKNOWN_PRODUCT: 'Nieznany produkt',
      AMBIGUOUS_PRODUCT: 'Niejednoznaczny produkt',
      MISSING_PRODUCT_DISTRIBUTION: 'Brak dystrybucji produktu',
      DISTRIBUTION_POLICY_MISSING: 'Brak reguły dystrybucji produktu',
      CENTRAL_RECONCILIATION_UNSUPPORTED: 'Brak bezpiecznej rekonsyliacji centralnej',
      BLOCKED: 'Walidacja jest zablokowana',
      FAILED: 'Import nie powiódł się',
      SHIPMENT_MANUAL_RECONCILIATION_REQUIRED:
        'Wysyłka wymaga ręcznego uzgodnienia z istniejącym ruchem magazynowym',
    },
    testData: 'Dane testowe',
    summary: {
      total: 'Razem',
      processing: 'Przetwarzanie',
      ready: 'Gotowe',
      blocked: 'Zablokowane',
      duplicate: 'Duplikaty',
      conflict: 'Konflikty',
      overlapExistingConfirmed: 'Zachowane nakładanie',
      failed: 'Błędy',
      confirmed: 'Potwierdzone',
      cancelled: 'Anulowane',
    },
    uploadDurableBatch:
      'Trwała partia została zapisana. Otwórz ją albo obserwuj tutaj poszczególne pliki.',
    upload: {
      type: 'Typ importu',
      choose: 'Wybierz pliki XLSX',
      limits: 'Do 100 plików, 10 MB każdy i 100 MB na partię.',
      drop: 'Upuść pliki XLSX tutaj lub wybierz pliki',
      progress:
        '{{processed}} / {{total}} obsłużonych · {{accepted}} przyjętych · {{failed}} błędów · {{invalid}} nieprawidłowych · {{ready}} gotowych · {{inProgress}} w toku · {{cancelled}} anulowanych',
      technicalId: 'Identyfikator techniczny: {{id}}',
      fileList: 'Wybrane pliki importu',
      filename: 'Nazwa pliku',
      size: 'Rozmiar',
      detectedType: 'Rozpoznany typ',
      detectedDate: 'Rozpoznana data',
      state: 'Stan',
      actions: 'Działania',
      afterValidation: 'Po walidacji',
      retry: 'Ponów',
      remove: 'Usuń',
      uploading: 'Wysyłanie…',
      start: 'Wgraj {{count}} gotowych plików',
      retryFailed: 'Ponów błędne pliki',
      cancelRemaining: 'Anuluj pozostałe',
    },
    uploadState: {
      CHECKING: 'Sprawdzanie',
      READY: 'Gotowy',
      INVALID: 'Nieprawidłowy',
      UPLOADING: 'Wysyłanie',
      QUEUED: 'W kolejce',
      DUPLICATE: 'Duplikat źródła',
      FAILED: 'Błąd',
      CANCELLED: 'Anulowany',
    },
    errors: {
      invalidDate:
        'Podaj prawidłowy zakres dat. Data końcowa nie może być wcześniejsza od początkowej.',
      BULK_IMPORT_FILE_COUNT_INVALID: 'Partia przekracza 100 plików.',
      BULK_IMPORT_XLSX_REQUIRED: 'Dozwolone są wyłącznie pliki XLSX.',
      BULK_IMPORT_FILE_SIZE_INVALID: 'Plik musi mieć od 1 bajtu do 10 MB.',
      BULK_IMPORT_BATCH_SIZE_INVALID: 'Partia przekracza 100 MB.',
      DUPLICATE_SELECTED: 'Ten sam plik został już wybrany.',
      BULK_IMPORT_DUPLICATE_SOURCE: 'To źródło już istnieje w partii.',
      UPLOAD_NETWORK_ERROR: 'Wysyłanie przerwane. Ponów ten plik.',
      INTERNAL_ERROR:
        'Nie udało się zapisać pliku (kod: INTERNAL_ERROR). Ponów plik; jeśli błąd się powtórzy, podaj identyfikator techniczny.',
      MASTER_DATA_LOCK_TIMEOUT:
        'Inna operacja aktualizuje dane podstawowe. Odśwież dane i spróbuj ponownie.',
      retryFailed: 'Ponowienie nie zostało przyjęte.',
      revalidateFailed: 'Ponowna walidacja nie powiodła się.',
      confirmFailed:
        'Potwierdzanie gotowych raportów nie powiodło się. Żaden raport nie został wymuszony.',
    },
  },
  shipmentWorkspace: {
    physicalQuantityBasis:
      'Ilości fizyczne uwzględniają zatwierdzone rozliczenia. Starsze raporty bez rozliczenia zachowują dotychczasową ilość z faktury; nie jest to dowód ruchu fizycznego.',
    sourceInvoiceQuantity: 'Ilość źródłowa z faktur',
    title: 'Wysyłki',
    description: 'Potwierdzone faktyczne wysyłki do sklepów według daty wysyłki.',
    openImports: 'Importy wysyłek',
    activeRange: '{{from}} — {{to}}',
    confirmedOnly: 'Tylko potwierdzone',
    activeFilters: 'Aktywne filtry: {{count}}',
    expandFilters: 'Pokaż filtry',
    collapseFilters: 'Zwiń filtry',
    datePreset: 'Okres',
    weekPeriods: 'Tydzień',
    preset: {
      '7d': '7 dni',
      '28d': '28 dni',
      '90d': '90 dni',
      ytd: 'YTD',
      current_week: 'Bieżący tydzień',
      previous_week: 'Poprzedni tydzień',
    },
    isoYear: 'Rok ISO',
    isoWeek: 'Tydzień ISO',
    isoWeekOption: 'Tydzień {{week}} · {{range}}',
    from: 'Od',
    to: 'Do',
    network: 'Sieć',
    allNetworks: 'Wszystkie sieci',
    store: 'Sklep',
    allStores: 'Wszystkie sklepy',
    productSearch: 'Szukaj produktu',
    product: 'Produkt',
    allProducts: 'Wszystkie produkty',
    orientation: 'Orientacja',
    storesByProducts: 'Sklepy × produkty',
    productsByStores: 'Produkty × sklepy',
    totalShipped: 'Wysłano łącznie',
    storesCount: 'Sklepy: {{count}}',
    productsCount: 'Produkty: {{count}}',
    factsCount: 'Pozycje źródłowe: {{count}}',
    loadFailed: 'Nie udało się wczytać macierzy wysyłek.',
    columns: 'Kolumny',
    resetColumnLayout: 'Przywróć kolumny',
    resetRowOrder: 'Przywróć kolejność',
    searchColumns: 'Szukaj kolumn',
    showAllColumns: 'Pokaż wszystkie',
    hideAllColumns: 'Ukryj wszystkie',
    allMatrixColumns: 'Wszystkie kolumny',
    visibleColumnsCount: 'Widoczne: {{visible}} / {{total}}',
    columnSearchResults: 'Wyniki wyszukiwania',
    showSearchResults: 'Pokaż wyniki wyszukiwania',
    hideSearchResults: 'Ukryj wyniki wyszukiwania',
    noColumnSearchResults: 'Brak pasujących kolumn',
    noProductsSelected: 'Nie wybrano produktów',
    noStoresSelected: 'Nie wybrano sklepów',
    pinColumn: 'Przypnij kolumnę',
    matrix: 'Macierz wysyłek',
    rowLabel: 'Sklep / produkt',
    sum: 'SUMA',
    empty: 'Brak potwierdzonych wysyłek do sklepów w wybranym okresie.',
    noShipment: 'Brak wysyłki',
    unit: { PIECE: 'szt.', KG: 'kg', TRAY: 'taca' },
    drillDown: 'Szczegóły wysyłki',
    byDay: 'Według dnia',
    date: 'Data wysyłki',
    quantity: 'Ilość',
    sourceEvidence: 'Niezmienne pozycje źródłowe',
    source: 'Źródło',
  },
  shipmentImports: {
    approvedRepair: {
      title: 'Pełny plan naprawy tej wysyłki',
      explanation:
        'Tylko Administrator. Podgląd odczytuje cały batch i stan katalogu; zapis wykonuje jeden atomowy Repair Plan, ale nie potwierdza Shipment.',
      loading: 'Odczytuję wszystkie linie i aktualne dane…',
      drift:
        'Stan batcha, tras, polityk lub produktu zmienił się. Niczego nie zapisano; przygotuj nowy podgląd.',
      saved: 'Plan zapisano z audytem',
      scope:
        '80907: PIECE→KG; cztery trasy; 80862/80865: MAIN→ELDHUS od 01.10; polityki Prís; dwa anulowania fakturowe −528 bez ruchu fizycznego. Dodatnich +180 nie łączymy ani nie zmieniamy.',
      preview: 'Przygotuj świeży podgląd całego planu',
      issueResult: 'Problemy: {{before}} przed planem, {{after}} po planie.',
      decisions:
        'Trasy: {{routes}} · przejścia: {{transitions}} · polityki: {{policies}} · decyzje fizyczne: {{physical}} · zmiana jednostki: 1',
      remainingNegatives: 'Pozostałe ujemne linie bez decyzji: {{count}}.',
      effectZero:
        'Ten zapis tworzy 0 raportów, faktów i ruchów; nie wykonuje confirmation ani KEEP/REPLACE.',
      noConfirmation:
        'To jest tylko naprawa mapowań i decyzji. Nakładający się raport i pozostałe ujemne pozycje mogą nadal blokować potwierdzenie.',
      reason: 'Uzasadnienie Administratora',
      confirmationHint: 'Wpisz dokładnie',
      confirmation: 'Potwierdzenie planu',
      close: 'Zamknij',
      apply: 'Zastosuj cały Repair Plan',
    },
    repairRoute: {
      title: 'Zmień zatwierdzone globalne trasy wysyłek',
      help: 'Audytowany Repair Plan dostępny tylko dla Admina. Zmiana dotyczy wyłącznie SKU 80862 i 80865: zamyka dokładne, otwarte trasy MAIN i rozpoczyna ELDHUS od 2026-10-01. Obie zmiany są atomowe; Shipment nie zostaje potwierdzony.',
      failed:
        'Nie udało się przygotować ani zastosować zmiany tras. Nie zapisano częściowej zmiany.',
      saved:
        'Zmiana tras została zapisana wraz z audytem i outboxem; Shipment pozostaje niepotwierdzony.',
      loading: 'Sprawdzam aktualne trasy i revisions magazynów…',
      drift:
        'Globalne trasy lub aktywny magazyn ELDHUS różnią się od zatwierdzonego stanu. Akcja jest niedostępna.',
      revision: 'oczekiwana revision {{revision}}',
      reason: 'Uzasadnienie zatwierdzone przez właściciela',
      preview: 'Podgląd zmiany atomowej',
      previewSummary: 'Przewidywane problemy: {{before}} przed zmianą, {{after}} po niej.',
      confirmation: 'Dokładne potwierdzenie',
      close: 'Zamknij',
      apply: 'Zastosuj Repair Plan',
      saving: 'Zapisywanie…',
    },
    incremental: {
      title: 'Przyrostowy import wysyłek',
      explanation:
        'Dokładne powtórzenia według faktury pozostają dowodem źródłowym i są pomijane. Fakty i ruchy mogą powstać tylko dla nowych dostaw.',
      repeated: 'Powtórzone wiersze źródłowe: {{count}}',
      new: 'Nowe dostawy: {{count}}',
      decision: 'Wymagają decyzji: {{count}}',
      blocked:
        'Zmienione lub niejednoznaczne wiersze wymagają jawnego rozliczenia; nic nie zostanie zastąpione automatycznie.',
      confirm: 'Pomiń powtórzenia i dodaj tylko nowe wysyłki',
      confirmationSummary:
        'Do potwierdzenia: {{added}} nowych pozycji; pominięte powtórzenia: {{repeated}}; zmienione: {{changed}}; zatwierdzone korekty: {{corrections}}.',
      recipientCorrection: 'Korekta odbiorców: {{totals}}',
      warehouseCorrection: 'Korekta magazynów: {{totals}}',
      canonicalUnchanged: 'Istniejący potwierdzony raport nie zostanie zastąpiony.',
    },
    physical: {
      stale:
        'Dane zmieniły się od zatwierdzenia rozliczenia. Poprzednia wersja pozostaje w historii; wymagany jest nowy podgląd i zatwierdzenie.',
      reapprove: 'Przygotuj nową wersję rozliczenia',
      title: 'Rozliczenie fizycznych ruchów',
      help: 'Ilości i faktury źródłowe pozostają niezmienne. Decyzje sterują wyłącznie przyszłymi ruchami fizycznymi; zapis nie potwierdza Shipment.',
      failed:
        'Operacja nie powiodła się. Sprawdź zakres i aktualny stan partii; żadna wysyłka nie została automatycznie potwierdzona.',
      loading: 'Wczytywanie…',
      saved: 'Decyzje zapisane z audytem. Shipment nie został automatycznie potwierdzony.',
      noNegative: 'Brak ujemnych pozycji do rozliczenia.',
      source: 'Źródło / faktura netto',
      kind: 'Rodzaj zdarzenia',
      choose: 'Wybierz zdarzenie',
      original: 'Powiązana dodatnia pozycja',
      linkHelp: 'Wybierz wyłącznie potwierdzone powiązanie. Zgodna ilość nie dowodzi powiązania.',
      priorFact: 'Potwierdzony fact z wcześniejszego raportu (korekta legacy)',
      priorFactHelp:
        'Użyj wyłącznie ID zweryfikowanego przez Administratora. To dowód na poziomie raportu/transakcji, nigdy zgadywany ruch historyczny.',
      unlinked:
        'Pierwotna faktura nieustalona: zero ruchów tylko dla wskazanej ujemnej pozycji. Inne dodatnie dostawy pozostają bez zmian.',
      reason: 'Uzasadnienie decyzji',
      summary: 'Źródło a skutki fizyczne',
      movementCount: 'Przyszłe ruchy ledger: {{count}}',
      unit: 'Jednostka',
      destinationNet: 'Delta odbiorców',
      warehouseNet: 'Delta magazynów źródłowych',
      confirmation: 'Jawne potwierdzenie zakresu',
      close: 'Zamknij',
      preview: 'Podgląd skutków',
      saving: 'ZAPISYWANIE…',
      save: 'Zapisz decyzje — bez potwierdzania Shipment',
      CANCEL_BEFORE_DISPATCH: 'Anulowanie przed wysyłką — obie powiązane pozycje bez ruchów',
      INVOICE_ONLY_NO_DISPATCH: 'Błąd faktury bez wysyłki — pierwotna pozycja nieustalona',
      DISPOSAL: 'Utylizacja u odbiorcy — bez przyjęcia do magazynu',
      RETURN_TO_STOCK: 'Fizyczny zwrot — przyjęcie do magazynu źródłowego',
    },
    title: 'Oficjalne wysyłki',
    description: 'Wgrywanie, walidacja, potwierdzanie i rollback oficjalnych skoroszytów wysyłek.',
    upload: 'Wgraj skoroszyt',
    history: 'Historia importów',
    filename: 'Nazwa pliku',
    shipmentDates: 'Daty wysyłek',
    status: 'Status',
    uploaded: 'Wgrano',
    destinations: 'Odbiorcy',
    products: 'Produkty',
    lines: 'Linie wysyłki',
    total: 'Łączna ilość',
    ledger: 'Rejestr magazynowy',
    pipeline: 'Pipeline sieci',
    preview: 'Podgląd i walidacja mapowań',
    issues: 'Problemy blokujące',
    date: 'Data',
    destination: 'Odbiorca',
    destinationType: 'Typ odbiorcy',
    product: 'Produkt',
    warehouse: 'Magazyn źródłowy',
    warehouseRouteMissing: 'Brak trasy magazynowej produktu',
    warehouseSourceDestinationMatch: 'Magazyn źródłowy i docelowy muszą być różne',
    confirm: 'Potwierdź oficjalny raport wysyłek',
    revalidate: 'Sprawdź mapowania ponownie',
    resolveStore: 'Dodaj lub połącz sklep',
    rollback: 'Wycofaj raport',
    rollbackReason: 'Obowiązkowy powód rollbacku',
    detail: 'Szczegóły raportu wysyłek',
    duplicate: 'Ten skoroszyt duplikuje istniejące dane wysyłek i nie może zostać potwierdzony.',
    conflict: 'Nakładanie się na potwierdzoną wysyłkę wymaga uzgodnienia przed potwierdzeniem.',
    semantics:
      'Dodatnia wysyłka bezpośrednia zwiększa stan sklepu i zmniejsza magazyn źródłowy. Dostawa magazynowa zwiększa magazyn docelowy i zmniejsza magazyn źródłowy. Wysyłka centralna zmniejsza magazyn i księguje tylko pipeline. Ujemne linie centralne są blokowane.',
    choose: 'Wybierz oficjalny skoroszyt wysyłek .xlsx',
    back: 'Wróć do historii importów',
    download: 'Pobierz oryginał',
    unconfirmedDates: 'Daty stają się oficjalne dopiero po potwierdzeniu',
    matchProduct: 'Dopasuj produkt',
    canonicalProduct: 'Produkt kanoniczny',
    matchProductHelp:
      'Dopasowanie zapisuje ręczny alias źródłowy. Raport pozostaje zablokowany do ponownej walidacji.',
    newProductUnit: 'Jednostka nowego produktu',
    createProduct: 'Utwórz nowy produkt',
    matchExistingProduct: 'Dopasuj istniejący produkt',
    leaveUnresolved: 'Pozostaw nierozstrzygnięte',
    operationFailed: 'Nie udało się wykonać importu wysyłek.',
    failure: {
      SHIPMENT_HEADER_INVALID: 'Plik wysyłek ma nieprawidłowy układ nagłówków.',
      SHIPMENT_DATE_INVALID: 'Plik wysyłek zawiera nieprawidłową datę.',
      SHIPMENT_INVOICE_NUMBER_REQUIRED: 'W wierszu wysyłki brakuje numeru faktury.',
      SHIPMENT_INVOICE_NUMBER_UNSAFE_NUMERIC:
        'Numer faktury został zapisany w Excelu jako niebezpieczna liczba i mógł utracić cyfry. Ustaw kolumnę Invoice # jako Tekst i ponownie wpisz oryginalny numer.',
      SHIPMENT_INVOICE_NUMBER_INVALID:
        'Numer faktury ma nieobsługiwany typ lub format. Ustaw kolumnę Invoice # jako Tekst.',
      SHIPMENT_INVOICE_NUMBER_TOO_LONG:
        'Numer faktury jest za długi. Maksymalna długość to 128 znaków.',
      SHIPMENT_QUANTITY_MISSING: 'W wierszu wysyłki brakuje ilości.',
      SHIPMENT_REQUIRED_VALUE_MISSING: 'W pliku wysyłek brakuje wymaganej wartości.',
      SHIPMENT_DESTINATION_INVALID: 'Plik wysyłek zawiera nieprawidłowego odbiorcę.',
      SHIPMENT_PRODUCT_INVALID: 'Plik wysyłek zawiera nieprawidłową wartość produktu.',
      SHIPMENT_INVALID_NUMERIC_CELL: 'Plik wysyłek zawiera nieprawidłową ilość.',
      SHIPMENT_FORMULA_OR_RICH_CELL:
        'Wymagane pola pliku wysyłek muszą zawierać wartości, nie formuły.',
      SHIPMENT_ZERO_QUANTITY: 'Linia wysyłki nie może mieć ilości równej zero.',
      SHIPMENT_WORKSHEET_UNEXPECTED: 'Plik wysyłek musi zawierać jeden arkusz Netto.',
      SHIPMENT_LINES_MISSING: 'Plik wysyłek nie zawiera żadnych linii wysyłki.',
      SHIPMENT_MALFORMED_XLSX: 'Nie można odczytać skoroszytu wysyłek.',
      SHIPMENT_FILE_SIZE_INVALID: 'Plik wysyłek jest pusty lub przekracza dozwolony rozmiar.',
      SHIPMENT_NOT_XLSX: 'Źródło wysyłek nie jest prawidłowym plikiem XLSX.',
      SHIPMENT_XLSX_LIMIT_EXCEEDED: 'Skoroszyt wysyłek przekracza bezpieczne limity przetwarzania.',
      SHIPMENT_UNSAFE_XLSX_CONTENT:
        'Skoroszyt wysyłek zawiera nieobsługiwaną niebezpieczną zawartość.',
      SHIPMENT_STAGING_FAILED: 'Nie udało się przygotować danych wysyłki do walidacji.',
      SHIPMENT_PARSE_FAILED: 'Nie udało się odczytać danych z pliku wysyłek.',
    },
  },
  production: {
    title: 'Planowanie produkcji',
    planningOnly:
      'Planuj produkcję, zapisuj fakty rzeczywiste, a zapasy księguj dopiero przy ukończeniu.',
    product: 'Produkt',
    date: 'Data produkcji',
    location: 'Lokalizacja',
    planningUnit: 'Jednostka planowania',
    plannedQuantity: 'Planowana ilość',
    quantity: 'Ilość',
    status: 'Status',
    draft: 'Szkic',
    planned: 'Zaplanowane',
    actions: 'Działania',
    openOrder: 'Otwórz',
    loading: 'Ładowanie zlecenia produkcyjnego…',
    close: 'Zamknij',
    batchPending: 'Partia oczekuje',
    plannedVsActual: 'Planowany / rzeczywisty wynik',
    actualsNoLedger:
      'Fakty rzeczywiste są tymczasowe. Zapasy zostaną zaksięgowane dopiero przy ukończeniu.',
    actualOutput: 'Rzeczywisty wynik',
    actualInputs: 'Rzeczywiste wejścia',
    actual: 'Rzeczywiste',
    variance: 'Odchylenie',
    batch: 'Partia',
    expiry: 'Termin przydatności',
    actualMaterial: 'Rzeczywisty materiał',
    actualQuantity: 'Rzeczywista ilość',
    waste: 'Strata procesowa',
    wasteCategory: 'Kategoria straty',
    stage: 'Etap',
    machine: 'Maszyna/zasób',
    stageStartedAt: 'Początek etapu',
    stageEndedAt: 'Koniec etapu',
    operationMinutes: 'Minuty operacji',
    people: 'Osoby',
    saveActuals: 'Zapisz fakty',
    timingSummary: 'Czas całkowity: {{elapsed}} min · operacja: {{operation}} min',
    start: 'Rozpocznij',
    completeReview: 'Ukończ — zaksięguj sprawdzone efekty zapasów',
    cancel: 'Anuluj',
    reverse: 'Odwróć',
    inventoryEffectsPosted: 'Zaksięgowano efektów zapasów: {{count}}',
    orderStatus: {
      DRAFT: 'Szkic',
      PLANNED: 'Zaplanowane',
      IN_PROGRESS: 'W toku',
      COMPLETED: 'Ukończone',
      CANCELLED: 'Anulowane',
      REVERSED: 'Odwrócone',
    },
    savePlan: 'Zapisz plan',
    saveFailed: 'Nie udało się zapisać planu.',
    readOnly: 'Masz dostęp tylko do odczytu.',
    requirementsPreview: 'Podgląd wymagań',
    finishedOutput: 'Wynikowy produkt',
    requirement: 'Wymaganie',
    kind: 'Rodzaj',
    rolls: 'Pełne rolki',
    weeklyRequirements: 'Zapotrzebowanie tygodnia',
    previousWeek: 'Poprzedni tydzień',
    currentWeek: 'Bieżący tydzień',
    nextWeek: 'Następny tydzień',
    noPlans: 'Brak planów na wybrany tydzień.',
    selectedProduct: 'wybrany produkt',
    configurationHint:
      'Aby zaplanować {{product}}, administrator musi skonfigurować wersjonowaną recepturę i format pakowania. Dostępne materiały: {{materials}}.',
    configuration: 'Konfiguracja planowania',
    configurationWorkspaceHelp:
      'Recepturę, opakowania, folię i etapy produkcji konfiguruj w jednym workspace kosztowania. Planer pozostaje prosty.',
    openMaterials: 'Otwórz materiały',
    openProductConfiguration: 'Skonfiguruj produkt',
    readyToPlan: 'GOTOWY DO PLANOWANIA',
    configurationMissing: 'BRAKUJE KONFIGURACJI',
    configurationChecklist: {
      recipe: 'Receptura',
      output: 'Wynik / uzysk',
      packaging: 'Opakowanie',
      multivac: 'Multivac',
      stages: 'Etapy produkcji',
    },
    noConfiguredStages: 'Brak skonfigurowanych czasowych etapów produkcji.',
    newMaterial: 'Nowy materiał',
    materialCode: 'Kod materiału',
    materialName: 'Nazwa materiału',
    rollLengthMetres: 'Długość rolki (m)',
    stockManaged: 'Zarządzane magazynowo',
    costManaged: 'Zarządzane kosztowo',
    unit: 'Jednostka',
    createMaterial: 'Dodaj materiał',
    recipeVersion: 'Wersja receptury',
    referenceOutput: 'Referencyjny wynik',
    ingredient: 'Składnik',
    ingredientQuantity: 'Ilość składnika',
    createRecipe: 'Dodaj recepturę',
    formatVersion: 'Format pakowania',
    finishedPerUnit: 'Wynik na jednostkę',
    finishedUnit: 'Jednostka wyniku',
    packsPerUnit: 'Opakowania na jednostkę',
    packagingMaterial: 'Materiał opakowaniowy',
    packagingQuantity: 'Ilość opakowania',
    packsPerCycle: 'Opakowania na cykl',
    pitchMetres: 'Skok maszyny (m)',
    lowerFilm: 'Folia dolna',
    upperFilm: 'Folia górna',
    createFormat: 'Dodaj format',
    chooseProductFirst: 'najpierw wybierz produkt',
    missing: {
      PRODUCTION_FORMAT_REQUIRED: 'Brakuje aktywnego formatu pakowania dla tej jednostki i daty.',
      PRODUCTION_RECIPE_REQUIRED: 'Brakuje aktywnej receptury dla tego produktu i daty.',
      PRODUCTION_RECIPE_OUTPUT_UNIT_MISMATCH:
        'Jednostka wyjścia receptury nie zgadza się z formatem. Skonfiguruj jawną relację.',
      PRODUCTION_FILM_CONFIGURATION_REQUIRED:
        'Konfiguracja filmu wymaga liczby opakowań na cykl oraz skoku maszyny.',
      PRODUCTION_FILM_ROLL_LENGTH_REQUIRED: 'Wybrany film wymaga skonfigurowanej długości rolki.',
      generic: 'Brakuje wymaganej konfiguracji produkcyjnej.',
    },
    requirementKinds: {
      INGREDIENT: 'Składnik',
      PACKAGING: 'Opakowanie',
      LOWER_FILM: 'Folia dolna',
      UPPER_FILM: 'Folia górna',
    },
  },
  dashboard: {
    title: 'Panel operacyjny',
    description: 'Tylko do odczytu: aktualność danych, sprzedaż i uwaga zapasów.',
    asOf: 'Stan na',
    network: 'Sieć',
    allNetworks: 'Wszystkie sieci',
    store: 'Sklep',
    allStores: 'Wszystkie sklepy',
    loadFailed: 'Nie udało się załadować panelu.',
    dataStatus: 'Status danych',
    latestSales: 'Ostatnia potwierdzona sprzedaż: {{date}}',
    coverage: 'Pokrycie 28 dni: {{status}}',
    missingSalesDays: 'Brakujące dni sprzedaży: {{count}}',
    stockIncomplete: 'Niepełne dane zapasów: {{count}}',
    stockNotInitialized: 'Zapas niezinicjalizowany: {{count}}',
    latestSalesImport: 'Ostatni import sprzedaży: {{date}}',
    latestShipmentImport: 'Ostatni import wysyłek: {{date}}',
    importsActionRequired: 'Importy wymagające działania: {{count}}',
    importsMissing: 'Brakujące raporty: {{count}} (Sprzedaż {{sales}}, Wysyłki {{shipments}})',
    oldestImportProblem: 'Najstarszy problem importu: {{date}}',
    salesSnapshot: 'Podsumowanie sprzedaży',
    period: 'Okres',
    knownQuantity: 'Znana ilość',
    coverageLabel: 'Pokrycie',
    activeScope: 'Zakres aktywny',
    storesProducts: '{{stores}} sklepów · {{products}} produktów',
    noSalesAccess: 'Ten użytkownik nie ma dostępu do szczegółów sprzedaży.',
    stockSummary: 'Podsumowanie uwagi zapasów',
    lowStock: 'Niskie / zamówienie: {{count}}',
    stockNotManaged: 'Zarządzane centralnie: {{count}}',
    noStockAccess: 'Ten użytkownik nie ma dostępu do szczegółów zapasów.',
    salesTrend: 'Trend znanej sprzedaży',
    salesTrendDescription:
      'Każdy znacznik to dzienna znana ilość. ? oznacza brak całego dnia sprzedaży, nigdy zero.',
    stockAttention: 'Uwagi zapasów',
    product: 'Produkt',
    current: 'Bieżący',
    goal: 'GOAL',
    difference: 'Różnica',
    reorder: 'Zamówienie',
    state: 'Stan',
    notNumeric: 'NIEZNANY',
    provisional: 'wstępne',
    noStockAttention: 'Brak pozycji wymagających uwagi w sklepach bezpośrednich.',
    topProducts: 'Najlepsze produkty wg znanej sprzedaży',
    storesCount: '{{count}} sklepów',
    dataIssues: 'Problemy z danymi',
    noDataIssues: 'Brak bieżących problemów z danymi.',
    recentImports: 'Ostatnia aktywność importów',
    coverageState: { COMPLETE: 'KOMPLETNE', INCOMPLETE_DATA: 'NIEPEŁNE DANE' },
    periods: {
      LATEST_CONFIRMED_DAY: 'Ostatni potwierdzony dzień',
      LAST_7_DAYS: 'Ostatnie 7 dni',
      LAST_28_DAYS: 'Ostatnie 28 dni',
    },
    issues: {
      MISSING_SALES_DAYS: 'Brak raportów sprzedaży: {{count}} dni',
      STOCK_INCOMPLETE_DATA: 'Niepełne komórki zapasów: {{count}}',
      STOCK_NOT_INITIALIZED: 'Niezainicjalizowane komórki zapasów: {{count}}',
      IMPORT_REVIEW_REQUIRED: 'Importy wymagające przeglądu: {{count}}',
    },
  },
  operations: {
    title: 'Operacje',
    previous: 'Poprzedni tydzień',
    current: 'Bieżący tydzień',
    next: 'Następny tydzień',
    loadFailed: 'Nie udało się wczytać operacji.',
    brief: 'Podsumowanie tygodnia',
    briefText:
      'W tym tygodniu: planowane {{planned}}, w toku {{inProgress}}, ukończone {{completed}}. Brakujące dni sprzedaży: {{missingSalesDays}}. Decyzje Shipment: {{shipmentOwnerDecisions}}.',
    production: 'Produkcja w tym tygodniu',
    openProduction: 'Otwórz produkcję',
    openWarehouse: 'Otwórz magazyn',
    storeOrders: 'Zamówienia sklepów',
    openStoreOrders: 'Otwórz Zamówienia',
    storeOrdersCoverage: '{{confirmed}} / {{expected}} potwierdzonych Sklepów · brak: {{missing}}',
    forecast: 'Prognoza na najbliższy tydzień',
    openForecast: 'Otwórz prognozę',
    forecastUnavailable: 'Brak jeszcze wygenerowanej prognozy.',
    lowConfidence: '{{count}} pozycji o niskiej pewności',
    date: 'Data',
    product: 'Produkt',
    quantity: 'Ilość',
    location: 'Lokalizacja',
    statusLabel: 'Status',
    moveDepartment: 'Przenieś do działu',
    noOrders: 'Brak zleceń produkcyjnych w tym tygodniu.',
    requirements: 'Zapotrzebowanie tygodnia',
    requirement: 'Wymaganie',
    kind: 'Rodzaj',
    rolls: 'Rolki',
    noRequirements: 'Brak planowanego zapotrzebowania.',
    attention: 'Wymaga uwagi',
    open: 'Otwórz',
    noIssues: 'Brak bieżących problemów operacyjnych.',
    issue: {
      missingSalesCoverage: 'Brakuje raportu Sales za {{count}} dzień/dni.',
      shipmentUnconfirmed: 'Raport Shipment pozostaje niepotwierdzony.',
      shipmentProductIdentities: 'Nierozstrzygnięte decyzje tożsamości Product: {{count}}.',
      shipmentWarehouseRoutes: 'Nierozstrzygnięte trasy źródłowego Warehouse: {{count}}.',
    },
    status: {
      DRAFT: 'Szkic',
      PLANNED: 'Planowane',
      IN_PROGRESS: 'W toku',
      COMPLETED: 'Ukończone',
      CANCELLED: 'Anulowane',
      REVERSED: 'Odwrócone',
    },
  },
  forecast: {
    title: 'Prognoza',
    model: 'Model {{version}} · Sprzedaż do {{through}}',
    noRun: 'Brak jeszcze wygenerowanej prognozy.',
    noRunEditor:
      'Brak jeszcze prognozy. Gdy dane sprzedażowe są gotowe, przelicz ją z danych autorytatywnych.',
    horizon: { 7: 'Następne 7 dni', 14: 'Następne 14 dni', 28: 'Następne 28 dni' },
    recalculate: 'Przelicz prognozę',
    recalculateFailed: 'Przeliczenie prognozy nie powiodło się.',
    addPromotion: 'Dodaj promocję',
    editPromotion: 'Edytuj promocję',
    productSearch: 'Szukaj produktu',
    product: 'Produkt',
    store: 'Sklep',
    network: 'Sieć',
    all: 'Wszystkie',
    date: 'Data',
    baseline: 'Bazowa',
    promotion: 'Promocja',
    final: 'Prognoza końcowa',
    confidence: 'Pewność',
    confidenceValue: { HIGH: 'Wysoka', MEDIUM: 'Średnia', LOW: 'Niska', NO_DATA: 'Brak danych' },
    manual: 'Ręczna',
    manualOverride: 'Ręczna zmiana prognozy',
    overrideQuantity: 'Końcowa ilość ({{unit}})',
    reason: 'Powód',
    saveOverride: 'Zapisz zmianę',
    explain: 'Wyjaśnij',
    drivers: 'Czynniki',
    close: 'Zamknij',
    scope: 'Zakres',
    from: 'Od',
    to: 'Do',
    uplift: 'Ręczny wzrost (%)',
    description: 'Opis',
    save: 'Zapisz',
    promotions: 'Promocje',
    noPromotions: 'Brak promocji.',
    noUplift: 'Brak ręcznego wzrostu',
    noRows: 'Brak prognoz dla wybranych filtrów.',
    noData: 'Brak danych',
    loadFailed: 'Nie udało się wczytać prognozy.',
  },
  costing: {
    recipeImportAction: 'Importuj recepturę',
    recipeImportTitle: 'Import receptury z dokumentu',
    recipeImportHelp:
      'Odczytamy składniki dla produktu {{product}}. Istniejące materiały zostaną użyte ponownie, a brakujące utworzone bez ceny.',
    recipeImportChooseFile: 'Wybierz plik DOCX lub PDF',
    recipeImportFileTooLarge: 'Plik jest większy niż 8 MB.',
    recipeImportReading: 'Odczytywanie…',
    recipeImportPreview: 'Odczytaj i pokaż podgląd',
    recipeImportNotReady: 'Import wymaga poprawnego podglądu.',
    recipeImportOutputRequired: 'Podaj dodatnią wydajność gotowej receptury.',
    recipeImportExistingCount: 'Połączone z istniejącymi: {{count}}',
    recipeImportNewCount: 'Nowe materiały: {{count}}',
    recipeImportMissingPrices:
      'Nowe materiały zostaną zapisane bez ceny. Kalkulacja pozostanie częściowa do czasu uzupełnienia kosztów.',
    recipeImportOutputQuantity: 'Wydajność gotowej receptury',
    recipeImportOutputUnit: 'Jednostka wydajności',
    recipeImportOutputHelp: 'Wpisz rzeczywistą ilość gotowego produktu dla tej receptury.',
    recipeImportSaving: 'Zapisywanie…',
    recipeImportSave: 'Utwórz materiały i zapisz recepturę',
    recipeImportStatus: {
      MATCHED: 'Istniejący',
      NEW: 'Nowy bez ceny',
      UNIT_CONFLICT: 'Konflikt jednostki',
      AMBIGUOUS_MATCH: 'Niejednoznaczny',
    },
    recipeImportWarnings: {
      PDF_TEXT_UNAVAILABLE: 'PDF nie zawiera możliwego do odczytania tekstu.',
      DOCX_DOCUMENT_XML_MISSING: 'Nie udało się odczytać struktury dokumentu DOCX.',
      NO_RECIPE_INGREDIENTS_DETECTED: 'Nie znaleziono tabeli składników i ilości.',
      UNSUPPORTED_RECIPE_FILE_TYPE: 'Obsługiwane są pliki DOCX i tekstowe PDF.',
    },
    title: 'Kalkulator kosztów produktu',
    subtitle: 'Uniwersalna ekonomika standardowa, rzeczywista partia i R&D.',
    mode: 'Tryb',
    standard: 'Standardowy',
    actual: 'Rzeczywista partia',
    draft: 'Szkic / R&D',
    date: 'Data kalkulacji',
    product: 'Produkt',
    batch: 'Zakończona partia',
    select: 'Wybierz',
    draftName: 'Nazwa szkicu',
    outputQuantity: 'Ilość wyjściowa',
    output: 'Wynik',
    unit: 'Jednostka',
    material: 'Materiał',
    temporaryMaterial: 'Materiał tymczasowy',
    quantity: 'Ilość',
    unitCost: 'Koszt jednostkowy',
    addMaterial: 'Dodaj materiał / opakowanie',
    addAndUse: 'Dodaj do bazy i użyj',
    useOnlyThisCalculation: 'Użyj tylko w tej kalkulacji',
    materialKind: 'Typ',
    ingredient: 'Składnik',
    packaging: 'Opakowanie',
    explicitConsumable: 'Jawny materiał pomocniczy',
    stockManaged: 'Zarządzany magazynowo',
    lowerFilm: 'Folia dolna',
    upperFilm: 'Folia górna',
    labor: 'Robocizna',
    machine: 'Maszyna/zasób',
    addLine: 'Dodaj składnik kosztu',
    removeLine: 'Usuń',
    cancel: 'Anuluj',
    component: 'Składnik',
    componentType: 'Typ składnika',
    total: 'Suma',
    state: 'Stan',
    summary: 'Ekonomika',
    batchCost: 'Koszt partii',
    prices: 'Kandydackie ceny netto',
    pricesHint: 'Rozdziel ceny przecinkami',
    targetMargin: 'Docelowa marża (%)',
    targetPrice: 'Wymagana cena netto',
    whatIf: 'Zmiana kosztu what-if (%)',
    scenarioCost: 'Koszt partii scenariusza',
    sellingPrice: 'Cena sprzedaży netto',
    profit: 'Zysk / jednostkę',
    margin: 'Marża',
    markup: 'Narzut',
    batchProfit: 'Zysk partii',
    calculationUnavailable: 'Brakuje wymaganej konfiguracji lub danych kosztowych.',
    notCalculated: 'Nie wyliczono',
    notStarted: 'Nie rozpoczęto',
    materials: 'Surowce / receptura',
    production: 'Produkcja',
    materialsDescription: 'Składniki i wejścia receptury tej kalkulacji.',
    productionDescription:
      'Zarejestrowany lub scenariuszowy czas operacyjny, robocizna i koszt maszyny.',
    packagingDescription: 'Opakowanie, folia dolna, folia górna i jawne materiały pomocnicze.',
    sectionNavigation: 'Sekcje kalkulacji kosztu',
    stage: 'Etap',
    operatingTime: 'Czas operacyjny',
    provenance: 'Podstawa kosztu',
    noComponents: 'Brak składników w tej sekcji.',
    noOperationalStages: 'Brak dostępnych etapów operacyjnych.',
    addIngredient: 'Dodaj składnik',
    addPackaging: 'Dodaj opakowanie',
    addStage: 'Dodaj etap',
    recipeStagesHelp:
      'Opcjonalne czasowe etapy wykorzystują obowiązujące stawki robocizny i maszyny w pełnym koszcie partii.',
    stageCode: 'Kod etapu',
    minutes: 'Minuty',
    people: 'Osoby',
    materialsSubtotal: 'Suma surowców',
    productionSubtotal: 'Suma produkcji',
    packagingSubtotal: 'Suma opakowania',
    draftIdentity: 'Lokalny scenariusz R&D — nie zmienia dowodów operacyjnych.',
    standardIdentity: 'Rozwiązana receptura standardowa i efektywna podstawa kosztu.',
    actualIdentity: 'Fakty zakończonej partii i historyczna efektywna podstawa kosztu.',
    currency: 'Waluta',
    costSummary: 'Podsumowanie kosztów batcha',
    incompleteCost: 'Pokazana jest znana kwota, ale brakuje co najmniej jednego wymaganego kosztu.',
    unitCostCard: 'Koszt na jednostkę',
    perUnit: 'Na 1 {{unit}}',
    authoritativeUnitsOnly: 'Pokazywane są tylko jawnie przeliczalne jednostki autorytatywne.',
    sellingEconomics: 'Cena sprzedaży i marża',
    addPrice: 'Dodaj cenę',
    priceUnit: 'Netto ISK za {{unit}}',
    calculatePrice: 'Oblicz cenę',
    scenarios: 'Scenariusze (what-if)',
    scenariosDescription:
      'Wyłącznie lokalne porównanie; scenariusze nie zapisują ani nie księgują dowodów.',
    scenario: 'Scenariusz',
    baselineScenario: 'SCEN 1 — BAZOWY',
    whatIfScenario: 'WHAT-IF',
    costChange: 'Zmiana kosztu: {{percent}}%',
    totalCost: 'Łączny koszt jednostkowy',
    batchRevenue: 'Przychód batcha',
    priceComparison: 'Porównanie cen kandydackich',
    libraryTitle: 'Koszt produkcji produktów',
    libraryDescription:
      'Trwałe, wersjonowane modele kosztów produktów. Zapis nie księguje magazynu.',
    searchModels: 'Szukaj produktów i modeli',
    department: 'Dział',
    allDepartments: 'Wszystkie działy',
    productOtherDepartment: 'PRODUKT NALEŻY DO INNEGO DZIAŁU',
    favorites: 'Ulubione',
    favorite: 'Ulubione',
    rnd: 'R&D',
    noSavedVersion: 'Brak zapisanej wersji',
    noSavedModels: 'Brak zapisanych modeli kosztowych dla wybranych filtrów.',
    selectSavedModel: 'Wybierz zapisany model, aby otworzyć kalkulację i historię.',
    versionHistory: 'Niezmienna historia wersji',
    immutableSnapshots:
      'Zapisane wersje są niezmiennym dowodem; przeliczenie tworzy nową wersję z aktualnymi kosztami efektywnymi.',
    reopen: 'Otwórz ponownie',
    recalculate: 'Przelicz',
    useAsTemplate: 'Użyj jako szablonu',
    copy: 'kopia',
    saveDraft: 'Zapisz szkic',
    saveNewVersion: 'Zapisz nową wersję',
    newProductModel: 'Model kosztu produktu',
    approveStandardCost: 'Zatwierdź koszt standardowy',
    approvalHelp:
      'Tworzy jawnie koszt standardowy Produktu z datą obowiązywania używany przez Rentowność. Nie księguje magazynu.',
    effectiveFrom: 'Obowiązuje od',
    reason: 'Powód',
    approve: 'Zatwierdź',
    costingChecklist: 'Lista kontrolna kosztowania',
    versionComparison: 'Aktualnie {{current}} · poprzednio {{previous}}',
    productLibrary: 'Produkty',
    costInputBase: 'Baza kosztów',
    excludedProducts: 'Wyłączone',
    excludeFromCosting: 'Wyłącz z kalkulacji',
    restoreCosting: 'Przywróć do kalkulacji',
    openProductEditor: 'Otwórz edytor',
    unassignedDepartment: 'Nieprzypisane',
    code: 'Kod',
    currentCost: 'Aktualny koszt',
    costHistory: 'Historia kosztu',
    actions: 'Działania',
    setCost: 'Ustaw koszt',
    setRate: 'Ustaw stawkę',
    rateAmount: 'Stawka',
    saveRate: 'Zapisz stawkę',
    costNotManaged: 'Koszt niezarządzany',
    complete: 'Kompletny',
    missingCost: 'Brak kosztu',
    hour: 'godz.',
    noRates: 'Brak aktywnych stawek.',
    purchaseAmount: 'Kwota zakupu',
    purchaseQuantity: 'Ilość zakupu',
    derivedUnitCost: 'Koszt jednostkowy zostanie wyliczony dokładnie.',
    sourceReference: 'Źródło / referencja',
    fxRate: 'Kurs do ISK',
    saveCost: 'Zapisz koszt',
    filmRollCostHelp: 'Cena rolki jest przeliczana przez długość: {{length}}.',
    requiredMetres: 'Zużycie: {{metres}}',
    practicalRolls: 'rolki praktyczne: {{count}} × {{length}}',
    rollLength: 'Długość rolki (m)',
    canonicalConfiguration: 'Konfiguracja Produkcji',
    canonicalConfigurationHelp:
      'Tworzy wyłącznie nową wersję istniejącej Receptury lub Formatu Produkcyjnego.',
    recipeLines: 'Linie receptury',
    saveRecipeVersion: 'Zapisz wersję receptury',
    planningUnit: 'Jednostka planowania',
    packsPerPlanningUnit: 'Opakowania na jednostkę planowania',
    packagingLines: 'Linie opakowania',
    filmMultivac: 'Folia / Multivac',
    packsPerCycle: 'Opakowania na cykl',
    pitchMetres: 'Skok (metry)',
    filmConfigurationRequired: 'Folia wymaga liczby opakowań na cykl i skoku.',
    saveFormatVersion: 'Zapisz wersję formatu',
    standardShort: 'STD',
    archive: 'Archiwizuj',
    materialsMasterTitle: 'Materiały i składniki',
    materialsMasterDescription:
      'Jedna wspólna baza materiałów dla receptur, opakowań i kosztowania.',
    searchMaterials: 'Szukaj po kodzie lub nazwie',
    newMaterial: 'Nowy materiał',
    materialCode: 'Kod materiału',
    materialName: 'Nazwa materiału',
    materialCodeHelp: 'Kod wewnętrzny / ERP / dostawcy, np. 51465',
    materialNameHelp: 'Nazwa używana w recepturach, np. Nauta Hakkefni',
    savingMaterial: 'ZAPISYWANIE...',
    materialCreateSuccess: 'Materiał został dodany.',
    materialCreateErrors: {
      duplicateCode: 'Materiał o kodzie {{code}} już istnieje.',
      invalidCategoryOrUnit: 'Wybierz poprawny typ materiału i jednostkę.',
      permissionDenied: 'Nie masz uprawnienia do dodawania materiałów.',
      validationFailed: 'Sprawdź wymagane pola i poprawność danych.',
      saveFailed: 'Nie udało się zapisać materiału. Spróbuj ponownie.',
    },
    allMaterials: 'Wszystkie',
    noMaterials: 'Brak materiałów spełniających filtr.',
    usedBy: 'Używany w',
    active: 'Aktywny',
    archived: 'Wyłączony',
    yes: 'Tak',
    no: 'Nie',
    close: 'Zamknij',
    save: 'Zapisz',
    costManaged: 'Uwzględniaj w kalkulacji kosztu',
    trackStock: 'Śledź stan magazynowy',
    includeCost: 'Uwzględniaj w kalkulacji kosztu',
    materialNoCostHelp:
      'Materiał bez kosztowania nie wymaga ceny i nie obniża kompletności kosztu, dopóki nie jest używany jako kosztowy.',
    rollLengthHelp: 'Długość jednej rolki w metrach. Koszt rolki jest przeliczany na metr.',
    noCostHistory: 'Brak zapisanej historii kosztu.',
    loadFailed: 'Nie udało się wczytać materiałów.',
    materialCategory: {
      RAW_MATERIAL: 'Surowiec',
      ADDITIVE: 'Dodatek',
      PACKAGING: 'Opakowanie',
      FILM: 'Folia',
      UNCLASSIFIED: 'Niesklasyfikowane',
    },
    productionCostWorkspace: 'Koszt produkcji',
    productionCostWorkspaceDescription:
      'Pełna ekonomika partii od surowców do marży sprzedaży. Każda wersja zachowuje snapshot cen.',
    calculator: 'Kalkulator',
    calculationHeader: 'Nagłówek kalkulacji',
    calculationHeaderHelp: 'Tożsamość, podstawa partii i kontekst handlowy tej wersji.',
    standardCalculation: 'Standardowa',
    researchCalculation: 'R&D',
    finishedProduct: 'Produkt gotowy',
    recipe: 'Receptura',
    recipeVersion: 'Receptura v{{version}}',
    noActiveRecipe: 'Brak aktywnej receptury',
    calculationName: 'Nazwa kalkulacji',
    newCalculation: 'Nowa kalkulacja',
    variant: 'Wariant produktu',
    inputBatchKg: 'Masa wejściowa partii (kg)',
    pieceWeightGrams: 'Gramatura sztuki (g)',
    piecesPerCarton: 'Sztuk w kartonie',
    customerOrNetwork: 'Klient / sieć',
    noSpecificCustomer: 'Bez konkretnego klienta',
    searchProduct: 'Szukaj po kodzie, nazwie lub aliasie',
    searchMaterial: 'Szukaj po kodzie lub nazwie',
    recentlyUsed: 'ostatnio używany',
    activeRecipe: 'aktywna receptura',
    openProductCard: 'Otwórz kartę produktu',
    noCurrentPrice: 'Brak aktualnej ceny',
    historicalPrice: 'Cena historyczna',
    priceEffectiveOn: 'Cena obowiązująca {{date}}',
    abpPrice: 'Cena ABP',
    abpPriceEffectiveOn: 'ABP · {{date}}',
    catalogGroup: {
      rawMaterials: 'Surowce lokalne',
      additives: 'Dodatki',
      packaging: 'Opakowania',
      abp: 'Surowce ABP',
      manual: 'Pozycja ręczna',
      networks: 'Sieci',
      stores: 'Sklepy',
    },
    note: 'Notatka',
    additionalSettings: 'Dodatkowe ustawienia',
    additionalSettingsHelp: 'Opcjonalna nazwa, wariant, gramatura i notatka.',
    loadCanonicalRecipe: 'Wczytaj aktualną recepturę kanoniczną',
    recipeCalculationHelp: 'Wprowadź kilogramy składników albo dokładne udziały procentowe.',
    chooseProductOrAddIngredient: 'Wybierz produkt lub dodaj pierwszy składnik',
    missingCostData: 'Brak danych kosztowych',
    customerPrice: 'Cena dla klienta',
    recipePercent: 'Receptura procentowa',
    recipeKg: 'Receptura w kilogramach',
    manualEntry: 'Ręczna pozycja scenariusza',
    manualOverride: 'Ręczne nadpisanie',
    lossAndYield: 'Straty i uzysk produkcyjny',
    lossAndYieldHelp: 'Etapy strat są liczone sekwencyjnie i nigdy podwójnie.',
    addLossStage: 'Dodaj etap straty',
    lossMode: 'Jednostka straty',
    lossValue: 'Strata',
    massAfterStage: 'Masa po etapie',
    laborOperations: 'Operacje i robocizna',
    laborOperationsHelp: 'Pracownicy × godziny × koszt roboczogodziny z narzutami.',
    addOperation: 'Dodaj operację',
    operation: 'Operacja',
    hours: 'Godziny',
    hourlyLoadedCost: 'Koszt godziny z narzutami',
    machinesAndEnergy: 'Maszyny i energia',
    machinesAndEnergyHelp: 'Czas maszyn pozostaje jawnie oddzielony od robocizny.',
    addMachine: 'Dodaj maszynę',
    hourlyCost: 'Koszt godziny',
    packagingMaterials: 'Materiały opakowaniowe',
    packagingMaterialsHelp: 'Zużycie na sztukę, karton lub partię wraz z odpadem.',
    calculationBasis: 'Sposób naliczania',
    consumption: 'Zużycie',
    wastePercent: 'Odpad materiału (%)',
    perPiece: 'Na sztukę',
    perCarton: 'Na karton',
    perBatch: 'Na partię',
    explicitOtherCosts: 'Pozostałe jawne koszty',
    explicitOtherCostsHelp:
      'Jakość, mycie, magazyn, logistyka, energia i odpady pozostają widoczne.',
    addExplicitCost: 'Dodaj jawny koszt',
    category: 'Kategoria',
    name: 'Nazwa',
    rate: 'Stawka',
    otherCategory: {
      QUALITY_CONTROL: 'Kontrola jakości',
      CLEANING_SANITATION: 'Mycie i dezynfekcja',
      STORAGE: 'Magazynowanie',
      INTERNAL_LOGISTICS: 'Logistyka wewnętrzna',
      ADDITIONAL_ENERGY: 'Dodatkowa energia',
      WASTE_DISPOSAL: 'Utylizacja odpadu',
    },
    costBasis: {
      PER_BATCH: 'Na partię',
      PER_KG: 'Na kg',
      PER_HOUR: 'Na godzinę',
      PER_PALLET: 'Na paletę',
    },
    netPriceHelp: 'Wszystkie ceny sprzedaży i marże są wartościami netto.',
    priceUnitLabel: 'Jednostka ceny sprzedaży',
    piece: 'sztuka',
    carton: 'karton',
    distributionCost: 'Koszt dystrybucji / partię',
    discountPercent: 'Rabat (%)',
    finishedMass: 'Masa gotowego produktu',
    yield: 'Uzysk',
    fullPieces: 'Pełne sztuki',
    fullCartons: 'Pełne kartony',
    costPerKg: 'Koszt / kg',
    costPerPiece: 'Koszt / szt.',
    costPerCarton: 'Koszt / karton',
    unsavedChanges: 'Niezapisane zmiany',
    discardUnsavedChanges: 'Odrzucić niezapisane zmiany kalkulacji?',
    archiveCalculationConfirm: 'Zarchiwizować kalkulację? Niezmienna historia pozostanie.',
    savingCalculation: 'ZAPISYWANIE…',
    calculationSaved: 'Wersja kalkulacji została zapisana.',
    calculating: 'Przeliczanie…',
    fixValidationErrors: 'Popraw wskazane błędy kalkulacji przed zapisem.',
    missingUsedCosts: '{{count}} używanych pozycji nie ma autorytatywnej ceny.',
    completeness: { COMPLETE: 'Kompletny', PARTIAL: 'Częściowy', UNKNOWN_COST: 'Brak kosztu' },
    validation: {
      INPUT_BATCH_MUST_BE_POSITIVE: 'Masa wejściowa musi być większa od zera.',
      RECIPE_PERCENT_MUST_EQUAL_100: 'Udziały receptury muszą wynosić dokładnie 100%.',
      LOSS_PERCENT_EXCEEDS_100: 'Strata procentowa nie może przekraczać 100%.',
      LOSS_EXCEEDS_AVAILABLE_MASS: 'Strata nie może przekraczać masy dostępnej na etapie.',
      PIECE_WEIGHT_MUST_BE_POSITIVE: 'Gramatura sztuki musi być większa od zera.',
      PACKAGING_CONVERSION_REQUIRED: 'Opakowanie na sztukę/karton wymaga jawnej gramatury.',
      SELLING_UNIT_CONVERSION_REQUIRED: 'Wybrana jednostka sprzedaży wymaga jawnego przeliczenia.',
      DISCOUNT_EXCEEDS_100: 'Rabat nie może przekraczać 100%.',
      TARGET_MARGIN_MUST_BE_BELOW_100: 'Docelowa marża musi być niższa niż 100%.',
      VALUE_MUST_BE_NON_NEGATIVE: 'Wartość nie może być ujemna.',
    },
    recipePercentTotal: 'Suma receptury',
    all: 'Wszystkie',
    approved: 'Zatwierdzony',
    sort: 'Sortowanie',
    sortUpdated: 'Ostatnio zmienione',
    sortCalculationDate: 'Data kalkulacji (najnowsze)',
    sortName: 'Nazwa',
    sortCostAsc: 'Koszt jednostkowy rosnąco',
    sortCostDesc: 'Koszt jednostkowy malejąco',
    sortMarginAsc: 'Marża rosnąco',
    sortMarginDesc: 'Marża malejąco',
    dateFrom: 'Data kalkulacji od',
    dateTo: 'Data kalkulacji do',
    comparisonDifference: 'Różnica',
    comparisonDifferencePercent: 'Różnica %',
    laborTime: 'Czas pracy',
    defaultApprovalReason: 'Zatwierdzony snapshot kosztu produkcji',
    departments: 'działy',
    calculations: 'kalkulacje',
    costBaseTruthHelp:
      'Materiały i efektywne stawki pracy/maszyn są wspólne z Produkcją; ten ekran nie tworzy drugiej bazy danych.',
    openMaterials: 'Otwórz bazę Materiałów',
    version: 'Wersja',
    compareVersions: 'Porównaj zapisane wersje',
    scenarioA: 'Scenariusz A',
    scenarioB: 'Scenariusz B',
    metric: 'Wskaźnik',
    restore: 'Przywróć',
  },
  orders: {
    title: 'Zamówienia sklepów',
    description:
      'Jawny popyt Sklepów według rundy dostawy. Bez Prognozy i bez odejmowania stanu Magazynu.',
    entry: 'WPROWADZANIE ZAMÓWIEŃ',
    summary: 'PODSUMOWANIE',
    submitted: 'ZŁOŻONE ZAMÓWIENIA',
    newRound: 'Nowa runda',
    closeRound: 'Zamknij rundę',
    round: 'Runda dostawy',
    deliveryDate: 'Data dostawy',
    reference: 'Referencja',
    expectedStores: 'Oczekiwane Sklepy',
    storesInOrder: 'Sklepy w zamówieniu',
    addStore: 'Dodaj Sklep',
    addStoreButton: 'Dodaj',
    addingStore: 'DODAWANIE...',
    removeStore: 'Usuń Sklep',
    removingStore: 'USUWANIE...',
    removeStoreConfirm: 'Usunąć {{store}} z tej rundy?',
    removeDraftStoreConfirm:
      'Ten sklep ma zapisany szkic. Usunąć szkic z bieżącej pracy i usunąć sklep z rundy?',
    cancelDraftAndRemove: 'Anuluj szkic i usuń',
    confirmedStoreRemoveBlocked: 'Sklep ma potwierdzone zamówienie. Najpierw anuluj zamówienie.',
    removeConfirmedStoreConfirm:
      'Anulować potwierdzone zamówienie dla {{store}} i usunąć sklep z tej rundy?',
    cancelConfirmedOrderAndRemove: 'Anuluj zamówienie i usuń sklep',
    confirmedOrderCancelledAndStoreRemoved: 'Zamówienie anulowane. Sklep usunięto z rundy.',
    roundUpdateErrors: {
      staleRevision: 'Runda została zmieniona. Odświeżono dane — spróbuj ponownie.',
      invalidStore: 'Nie można dodać wybranego sklepu.',
      roundNotEditable: 'Zamkniętej rundy nie można modyfikować.',
      activeStoreOrders: 'Sklepu z aktywnym zamówieniem nie można usunąć z rundy.',
      confirmedStoreLocked: 'Sklep ma potwierdzone zamówienie. Najpierw anuluj zamówienie.',
      addFailed: 'Nie udało się dodać sklepu.',
      removeFailed: 'Nie udało się usunąć sklepu.',
    },
    searchStore: 'Szukaj Sklepu',
    selectStore: 'Wybierz Sklep, aby wprowadzić zamówienie.',
    noRound: 'Brak otwartej rundy Zamówień.',
    noRoundForWeek:
      'Brak rundy Zamówień w tym tygodniu. Zamknięte tygodnie historyczne pozostają dostępne po wybraniu.',
    weekHeading: 'TYDZIEŃ {{week}} · {{from}}–{{to}}',
    previousWeek: 'Poprzedni tydzień',
    currentWeek: 'Bieżący tydzień',
    nextWeek: 'Następny tydzień',
    department: 'Dział',
    allDepartments: 'Wszystkie działy',
    network: 'Sieć',
    allNetworks: 'Wszystkie sieci',
    addProduct: 'Dodaj produkt',
    removeProduct: 'Usuń produkt',
    orderEditor: 'Edytor zamówienia',
    quantity: 'Ilość',
    note: 'Notatka',
    saveDraft: 'Zapisz szkic',
    confirm: 'Potwierdź zamówienie',
    confirmedStores: 'Potwierdzone Sklepy',
    missingStores: 'Brakujące Sklepy',
    product: 'Produkt',
    ordered: 'Zamówione',
    planned: 'Już zaplanowano',
    remaining: 'DO ZROBIENIA',
    statusLabel: 'Status',
    productionWarehouse: 'Magazyn Produkcji',
    createProduction: 'Utwórz plan Produkcji',
    ready: 'Gotowe',
    productionConfigured: 'Konfiguracja Produkcji',
    pickingRequired: 'DO KOMPLETACJI',
    overplanned: 'Nadplan',
    resetDepartmentOrder: 'Przywróć kolejność działów',
    resetProductOrder: 'Przywróć kolejność Produktów',
    storesList: 'Lista Sklepów',
    productMatrix: 'Macierz Produktów',
    store: 'Sklep',
    version: 'Wersja',
    confirmedAt: 'Potwierdzono',
    show: 'Pokaż',
    history: 'Historia wersji',
    previous: 'Poprzedni Sklep',
    next: 'Następny Sklep',
    create: 'Utwórz',
    cancel: 'Anuluj',
    loading: 'Ładowanie…',
    notReceived: 'Brak zamówienia',
    importOrderFile: 'Importuj plik zamówienia',
    fileImportReview: 'Przegląd importu pliku',
    pdfTextUnavailable: 'Ten PDF nie zawiera tekstu do automatycznego odczytu.',
    storeMatches: 'SKLEP ZGODNY',
    possibleStoreMismatch: 'MOŻLIWA NIEZGODNOŚĆ SKLEPU: wykryto {{store}}.',
    fileImportFailed: 'Nie udało się odczytać pliku. Możesz wpisać zamówienie ręcznie.',
    selectedStore: 'Wybrany Sklep: {{store}}',
    readFromImage: 'Odczytaj ze zdjęcia',
    imageReview: 'Przegląd odczytu zdjęcia',
    imageReadFailed: 'Nie udało się odczytać zdjęcia. Możesz wpisać zamówienie ręcznie.',
    retryImageRead: 'Spróbuj ponownie',
    enterManually: 'Wpisz ręcznie',
    reviewRequired: 'Wymaga weryfikacji',
    addToDraft: 'Dodaj do draftu zamówienia',
    sources: 'Źródła',
    removeLine: 'Usuń pozycję',
    rememberImageAlias: 'Zapamiętaj alias',
    imageState: {
      READY: 'GOTOWE',
      REVIEW: 'WERYFIKACJA',
      UNMATCHED: 'NIEDOPASOWANE',
      INVALID_QUANTITY: 'NIEPRAWIDŁOWA ILOŚĆ',
      UNIT_REVIEW: 'WERYFIKACJA JEDNOSTKI',
    },
    status: { NOT_RECEIVED: 'BRAK ZAMÓWIENIA', DRAFT: 'SZKIC', CONFIRMED: 'POTWIERDZONE' },
  },
  abpCatalog: {
    title: 'Katalog produktów ABP',
    subtitle:
      'Tylko do odczytu: produkty ABP, aktualne ceny zakupu i ostatni wiarygodny koszt finalny.',
    syncNow: 'Synchronizuj teraz',
    lastSync: 'Ostatnia poprawna synchronizacja: {{date}}',
    neverSynced: 'Jeszcze nie synchronizowano',
    productCount: 'Produkty: {{count}}',
    syncError:
      'Ostatnia synchronizacja nie powiodła się ({{code}}). Poprzedni poprawny katalog pozostaje dostępny.',
    notConfigured:
      'Synchronizacja ABP nie jest skonfigurowana. Istniejący cache pozostaje tylko do odczytu.',
    manualSyncFailed:
      'Ręczna synchronizacja nie powiodła się. Żaden zapisany produkt nie został usunięty.',
    search: 'Nazwa, alias lub PLU',
    freshFrozen: 'Fresh / Frozen',
    all: 'Wszystko',
    family: 'Rodzina',
    visibility: 'Widoczność',
    priceSource: 'Źródło ceny',
    dataCompleteness: 'Braki danych',
    sort: 'Sortuj',
    product: 'Produkt',
    plu: 'PLU',
    familyVariant: 'Rodzina / wariant',
    priceEur: 'Cena ABP EUR/kg',
    finalCost: 'Finalny ISK/kg',
    dataStatus: 'Status danych',
    details: 'Szczegóły',
    noResults: 'Brak produktów spełniających wybrane filtry.',
    loadFailed: 'Nie udało się wczytać katalogu ABP.',
    officialName: 'Oficjalna nazwa',
    abpId: 'Identyfikator ABP',
    hsCode: 'Kod HS',
    importMode: 'Metoda importu',
    costBasis: 'Podstawa kosztu',
    warnings: 'Ostrzeżenia',
    none: 'Brak',
    close: 'Zamknij',
    sync: {
      current: 'Aktualne',
      stale: 'Nieaktualne',
      error: 'Błąd synchronizacji',
      not_configured: 'Brak konfiguracji',
      empty: 'Pusty cache',
      syncing: 'Synchronizacja',
    },
    source: {
      pricebook: 'Aktywny cennik',
      invoiceFallback: 'Fallback: ostatnia faktura',
      missing: 'Brak ceny',
    },
    status: {
      available: 'Dostępny',
      unavailable: 'Niedostępny',
      hidden: 'Ukryty',
      review: 'Do kontroli',
      complete: 'Kompletne',
    },
    visibilityOption: {
      all: 'Wszystko',
      active: 'Aktywne',
      hidden: 'Ukryte',
      unavailable: 'Niedostępne',
    },
    missingOption: {
      any: 'Wszystkie',
      price: 'Brak ceny',
      cost: 'Brak kosztu',
      none: 'Cena i koszt kompletne',
    },
    sortOption: {
      name: 'Nazwa',
      plu: 'PLU',
      price_eur: 'Cena EUR',
      cost_isk: 'Koszt ISK',
      updated_at: 'Aktualizacja',
    },
    direction: { asc: 'Rosnąco', desc: 'Malejąco' },
    import: { tariff: 'Taryfa', quota: 'Kvótta', exempt: 'Zwolnione / 0%' },
    review: {
      missing_price: 'brak ceny',
      ambiguous_price_source: 'niejednoznaczne źródło ceny',
      missing_family: 'brak rodziny',
      missing_variant: 'brak wariantu',
      missing_fresh_frozen: 'brak Fresh/Frozen',
      missing_hs_code: 'brak kodu HS',
      missing_import_mode: 'brak metody importu',
      missing_final_cost: 'brak finalnego kosztu',
    },
  },
  profitability: {
    title: 'Rentowność',
    subtitle: 'Tylko do odczytu: sprzedaż netto z potwierdzonych faktów i historyczne koszty.',
    readOnly: 'Tylko odczyt',
    from: 'Od',
    to: 'Do',
    all: 'Wszystkie',
    product: 'Produkt',
    store: 'Sklep',
    network: 'Sieć',
    products: 'Produkty',
    stores: 'Sklepy',
    networks: 'Sieci',
    view: 'Widok',
    sort: 'Sortuj',
    direction: 'Kierunek',
    descending: 'Malejąco',
    ascending: 'Rosnąco',
    quantity: 'Ilość',
    revenue: 'Przychód netto',
    cost: 'Koszt',
    profit: 'Zysk',
    margin: 'Marża',
    completeness: 'Kompletność kosztu',
    date: 'Data',
    overTime: 'Rentowność w czasie',
    noRows: 'Brak potwierdzonej sprzedaży dla wybranych filtrów.',
    loadFailed: 'Nie udało się wczytać rentowności.',
    costProvenance: 'Pochodzenie kosztu',
    standardOnly:
      'Stosowany jest standardowy koszt historyczny. Rzeczywisty koszt partii nigdy nie jest zgadywany bez autorytatywnego powiązania sprzedaży z partią.',
    costVersionCount_one: '{{count}} wersja standardowego kosztu',
    costVersionCount_other: '{{count}} wersje standardowego kosztu',
    state: { COMPLETE: 'Kompletne', PARTIAL: 'Częściowe', UNKNOWN_COST: 'Nieznany koszt' },
    basis: {
      STANDARD_EFFECTIVE: 'Historyczny koszt standardowy',
      NO_AUTHORITATIVE_COST: 'Brak autorytatywnego kosztu',
    },
  },
} satisfies LocaleResources;
